import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import {  Navbar, NavController, NavParams, ToastController, PopoverController, ViewController, AlertController, ModalController } from 'ionic-angular';
import firebase from 'firebase/app';
import { Http, Headers, RequestOptions } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireStorage } from 'angularfire2/storage';
import { ViewContactPdfPage } from '../view-contact-pdf/view-contact-pdf';
import { LoadingProvider } from '../../providers/loading/loading';
import { StepformPage } from '../stepform/stepform';
import { EditPopoverPage } from '../edit-popover/edit-popover';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AllowCustomerPermissionPage } from '../allow-customer-permission/allow-customer-permission';
import {AdfCustomerPermissionPage} from '../adf-customer-permission/adf-customer-permission';
import { TentativeRealEstateAssetPage } from '../tentative-real-estate-asset/tentative-real-estate-asset';
import { ChangeLogProfilePage } from '../change-log-profile/change-log-profile';
import { HistoryDetailsPage } from '../history-details/history-details';
import { ViewMoreAddressPage } from '../view-more-address/view-more-address';
import { SdfFormService } from '../../app/services/sdf-form-service';
import { AngularFireAuth } from 'angularfire2/auth';
import RealEstatePage from '../real-estate/real-estate';
import { EnvDataService } from '../../app/services/env-data-service';
import { ContactFormService } from '../edit-contact-form-list/services/contact-form.service';
import { data } from 'jquery';
import {AdfPage} from '../adf-page/adf-page';
import { ADFFormService } from '../adf-page/services/adf-form.service';
// import { a } from '@angular/core/src/render3';
import { ShowContactForm } from '../show-contact/show-contact';
import { AdfList } from '../adf-list/adf-list';
export interface Image {
  id: string;
  image: string;
}
@Component({
  selector: 'page-view-adf',
  templateUrl: 'view-adf.html',
  providers: [EnvDataService, ContactFormService,ADFFormService],
})
export class ViewAdfPage {

  @ViewChild(Navbar) navBar: Navbar;

  url: any;
  newImage: Image = {
    id: this.db.createId(), image: ''
  }
  loading: boolean = false;
 

  updateEmailPhoneForm: FormGroup;
  updateEmailPhoneFormSec: FormGroup;
  ReviewByCustomer: FormGroup;
  public userAccessEdit: any;
  public userAccessView: any;
  public usersDetails: any;
  public contact_uid: any;
  public singleUserDetails: any;
  public unique_key: any;
  public user_data: any;
  public user_data_address:any;
  public user_address:any;
  public employment: any;
  public incomes: any;
  public incomesSec: any;
  public assets: any = [];
  public assetsSec: any;
  public primary_tag: any;
  public secondary_tag: any;
  public liabilities: any = [];
  public liabilitiesSec: any;
  public realestates: any;
  public tentativerealestates: any;
  public tentativerealestatesa: any;
  public tentativerealestatesaa: any;
  public total_current_balance: any;
  public total_mortgage_limit: any;
  public total_asset_value: any;
  public total_available_redraw: any;
  public total_repayments: any;
  public total_annual_repayments_limit: any;
  public total_gross_amount: any;
  public total_rent_annual: any;
  public total_lvr: any;
  public total_tentative_current_balance: any;
  public total_tentative_current_balance1: any;
  public total_tentative_mortgage_limit: any;
  public total_tentative_mortgage_limit1: any;
  public total_tentative_asset_value: any;
  public total_tentative_asset_value1: any;
  public total_tentative_available_redraw: any;
  public total_tentative_available_redraw1: any;
  public total_tentative_repayments: any;
  public total_tentative_repayments1: any;
  public total_tentative_annual_repayments_limit: any;
  public total_tentative_annual_repayments_limit1: any;
  public total_tentative_gross_amount: any;
  public total_tentative_gross_amount1: any;
  public total_tentative_rent_annual: any;
  public total_tentative_rent_annual1: any;
  public total_tentative_lvr: any;
  public total_tentative_lvr1: any;
  public userRole: any;
  public accessPermissionStatus: any;
  public showDetails: any;
  public icon: any;
  public accessPermissioncheckstatus: any;
  public accessPermissionname: any;
  public accessPermissioncheckstatusPS: any;
  public accessPermissionnamePS: any;
  public primary_secondary_contact_uid: any;
  public primSecondContact: any;
  public primSecondEmployment: any;
  public trenumber: number;
  public document_id: any;
  submitAttempt: boolean = false;
  public agreed: any;
  public accessGrantedFromUserstatus: number;
  public assigned_broker_name: any;
  public annual_repayments_limit1: any;
  public annual_repayments_limit2: any;
  public realestateSplits: any;
  public split_current_balance: any;
  public split_mortgage_limit: any;
  public split_available_redraw: any;
  public split_repayments: any;
  public split_interest_rate: any;
  public split_creditor: any;
  public split_interest_rate_term: any;
  public split_loan_type: any;
  public split_tentative_creditor: any;
  public split_tentative_interest_rate_term: any;
  public split_tentative_loan_type: any;
  public showCurrentTentativetable: any = false;
  public showCurrentTentativetableIndex: any;

  public tentative_annual_repayments_limit1: any;
  public tentative_annual_repayments_limit2: any;
  public tentative_realestateSplits: any;
  public split_tentative_current_balance: any;
  public split_tentative_mortgage_limit: any;
  public split_tentative_repayments: any;
  public split_tentative_interest_rate: any;
  public primary_secondary_found: any;
  public editPhoneOption: number = 0;
  public editEmailOption: number = 0;

  public editPhoneOptionSecond: number = 0;
  public editEmailOptionSecond: number = 0;
  public tentativerealestatesGroup: any;
  public showHideTentativetable: any;
  public showHideLeaderAddressRealestate: any;
  public showHideLeaderAssetValueRealestate: any;
  public showHideLeaderOwnershipTitleNameRealestate: any;
  public showHideLeaderRentAnnualRealestate: any;
  public showHideLeaderGrossAmountRealestate: any;
  public showHideLeaderCreditorRealestate: any;
  public showHideLeaderMortgageLimitRealestate: any;
  public showHideLeaderCurrentBalanceRealestate: any;
  public showHideLeaderIntrestRateRealestate: any;
  public showHideLeaderInterestRateTermRealestate: any;
  public showHideLeaderLoanTypeRealestate: any;
  public showHideLeaderRepaymentsRealestate: any;

  public showHideLeaderAddressTentaRealestate: any;
  public showHideLeaderAssetValueTentaRealestate: any;
  public showHideLeaderOwnershipTitleTentaRealestate: any;
  public showHideLeaderRentAnnualTentaRealestate: any;
  public showHideLeaderGrossAmountTentaRealestate: any;
  public showHideLeaderCreditorTentaRealestate: any;
  public showHideLeaderMortgageLimitTentaRealestate: any;
  public showHideLeaderCurrentBalanceTentaRealestate: any;
  public showHideLeaderIntrestRateTentaRealestate: any;
  public showHideLeaderInterestRateTermTentaRealestate: any;
  public showHideLeaderLoanTypeTentaRealestate: any;
  public showHideLeaderRepaymentsTentaRealestate: any;

  public assets_data: any;
  public liabilities_data: any;
  public realEstate_data: any;
  public second_contact_data: any;
  public second_employment_data: any;
  public second_income_data: any;
  public second_asset_data: any;
  public second_liabilities_data: any;
  public userData: any;

  public all_documents: any;
  public percentage: any;
  public percentageArea: any;
  public priSec_uid: any;
  public approval_log: any;
  public approval_log_data: any;
  public user_history: any;
  public SDF_form_document_id: any;
  public secondary_applicant:any= [];
  public secondary_applicant_load = false;
  public realestates_load = false;

  public primary_contact_id:any;

  public adf_data :any;
  public adf_flag: any;
  public additionaladf_flag: any;

  public adfFormStatus:boolean = false;

  public contact_user_data :any;
  

  public validation_messages = {
    'email': [
      { type: 'required', message: 'Email is required.' }
    ],
    'mobile_phone': [
      { type: 'required', message: 'Mobile Number is required.' },
      { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
      { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
    ]
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http: Http,
    public db: AngularFirestore,
    public loadingProvider: LoadingProvider,
    public toastCtrl: ToastController,
    public popoverCtrl: PopoverController,
    public formBuilder: FormBuilder,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    private storage: AngularFireStorage,
    public SdfFormService: SdfFormService,
    public afAuth: AngularFireAuth,
    public modalCtrl: ModalController,
    private EnvDataService: EnvDataService,
    private ContactFormService: ContactFormService,
    private ADFFormService:ADFFormService
  ) {

    
   
    this.all_documents = [];
 

    window.localStorage.removeItem("creating_second");
    this.user_data = '';
    this.user_data_address='';
    this.user_address = '';

    this.employment = '';
    let thiss = this;
    this.trenumber = 1;
    this.total_tentative_current_balance1 = [];
    this.total_tentative_mortgage_limit1 = [];
    this.total_tentative_asset_value1 = [];
    this.total_tentative_available_redraw1 = [];
    this.total_tentative_repayments1 = [];
    this.total_tentative_annual_repayments_limit1 = [];
    this.total_tentative_gross_amount1 = [];
    this.total_tentative_rent_annual1 = [];
    this.total_tentative_lvr1 = [];
    this.primSecondContact = 0;
    this.primSecondEmployment = 0;
    this.accessGrantedFromUserstatus = 0;
    this.approval_log = '';
   

    this.userRole = window.localStorage.getItem("userRole");
    let createdContact_uid = window.localStorage.getItem("contact_uid");
    let uid = window.localStorage.getItem("uid");
    this.contact_uid = this.navParams.get("contact_uid");
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let contactUid = location.search.split('id=')[1];
    this.document_id = location.search.split('&docId=')[1];
    this.ReviewByCustomer = formBuilder.group({
      agreed: ['']
    });

    if (this.SDF_form_document_id == undefined || this.SDF_form_document_id == null || this.SDF_form_document_id == '') {
      this.SDF_form_document_id = window.localStorage.getItem("SDF_form_document_id");
    }

    if (this.document_id != undefined) {
      contactUid = contactUid.split('&docId=')[0];
    }
    if (contactUid == "" || contactUid == null || contactUid == undefined) { } else {
      this.contact_uid = contactUid;
    }

    if (this.contact_uid == "" || this.contact_uid == null || this.contact_uid == undefined) {
      if (createdContact_uid == "" || createdContact_uid == null || createdContact_uid == undefined) { } else {
        this.contact_uid = createdContact_uid;
      }
    }
    if (window.localStorage.getItem("userRole") == "contact") {
      this.contact_uid = window.localStorage.getItem("uid");
    }

    thiss.userAccessEdit = 0;
    thiss.userAccessView = 0;
    console.log(this.userRole, this.contact_uid);
    
    if(this.userRole === 'contact'){
      this.getContactDetails(this.contact_uid).subscribe((data) =>{
        
        console.log(data);
        this.contact_user_data = data[0];
        
        thiss.userAccessEdit = (data[0].allowCustoeditPermission == undefined) ? 0 : data[0].allowCustoeditPermission;
        thiss.userAccessView = (data[0].allowCustoViewOnlyPermission == undefined) ? 0 : data[0].allowCustoViewOnlyPermission;
      })
    }

    if (thiss.SDF_form_document_id != undefined) {
      this.ContactFormService.getspecificApplicationsById(thiss.SDF_form_document_id).then((data: any) => {
        console.log('data',data)
        debugger;
        var get_user_data = data;
        thiss.user_data = get_user_data;
        console.log(thiss.user_data);
        this.primary_contact_id = data.primary_contact_id;
        this.adf_data = data;

        if(this.adf_data.application_status !== 'closed') {
          this.adfFormStatus = true;
        }

        if(this.adf_data.hasOwnProperty('accessGrantedFromUser')){
          // console.log('yes exits');
          }
          else {
            this.adf_data.accessGrantedFromUser = 0;
          }

        console.log(this.primary_contact_id);
        debugger;
        data.contacts.forEach(contactelement => {

            if(contactelement.type == 'primary') {
              if(contactelement.contact_details.address) {
                this.user_data_address=contactelement.contact_details.address[0];
                this.user_address = contactelement.contact_details.address;
              }
              
              
              debugger;
            }

        });
        
        thiss.user_data.accessGrantedFromUser = (data.accessGrantedFromUser == undefined) ? 0 : data.accessGrantedFromUser;
        thiss.accessGrantedFromUserstatus = thiss.user_data.accessGrantedFromUser;


        // if (uid == thiss.user_data.uid) {
        //   thiss.userAccessEdit = (data.allowCustoeditPermission == undefined) ? 0 : data.allowCustoeditPermission;
        //   thiss.userAccessView = (data.allowCustoViewOnlyPermission == undefined) ? 0 : data.allowCustoViewOnlyPermission;
        // }

        

          if(data.assets) {
            if(data.assets.length > 0){

              thiss.assets = data.assets
            }
            else {
              thiss.assets = [];
            }
          }
          else {
            thiss.assets = [];
          }
          

          // data.contacts.forEach(contactelement => {

          //   contactelement.employment_details.incomes.forEach(incomeelement => {
              
          //     if(typeof incomeelement.amount == "string") {

          //       let amount_arr = incomeelement.amount.split("$");
          //       incomeelement.amount =  parseInt(amount_arr[1]);
                
          //     }

          //   });

          // });


        if (data.realestate !== undefined ||data.realestate.length==0) {
         

          if(data.realestate.length > 0){
            thiss.total_current_balance = parseInt('0');
            thiss.total_mortgage_limit = parseInt('0');
            thiss.total_asset_value = parseInt('0');
            thiss.total_available_redraw = parseInt('0');
            thiss.total_repayments = parseInt('0');
            thiss.total_annual_repayments_limit = parseInt('0');
            thiss.total_gross_amount = parseInt('0');
            thiss.total_rent_annual = parseInt('0');
            thiss.total_lvr = parseInt('0');
            thiss.realestateSplits = [];
            thiss.showHideLeaderAddressRealestate = [];
            thiss.showHideLeaderAssetValueRealestate = [];
            thiss.showHideLeaderOwnershipTitleNameRealestate = [];
            thiss.showHideLeaderRentAnnualRealestate = [];
            thiss.showHideLeaderGrossAmountRealestate = [];

            thiss.showHideLeaderCreditorRealestate = [];
            thiss.showHideLeaderMortgageLimitRealestate = [];
            thiss.showHideLeaderCurrentBalanceRealestate = [];
            thiss.showHideLeaderIntrestRateRealestate = [];
            thiss.showHideLeaderInterestRateTermRealestate = [];
            thiss.showHideLeaderLoanTypeRealestate = [];
            thiss.showHideLeaderRepaymentsRealestate = [];

            let showHideLeaderCreditorRealestate = [];
            let showHideLeaderMortgageLimitRealestate = [];
            let showHideLeaderCurrentBalanceRealestate = [];
            let showHideLeaderIntrestRateRealestate = [];
            let showHideLeaderInterestRateTermRealestate = [];
            let showHideLeaderLoanTypeRealestate = [];
            let showHideLeaderRepaymentsRealestate = [];
            let realestate = [];

            data.realestate.forEach(function (value, index) {
              if(!value.itemRowsMortgageSplits) {
                
                let splits = [];

                if(value.split == 0) {
                  value.itemRowsMortgageSplits = splits;
                }
                else {

                  value.split.forEach(splititem => {


                    // if(typeof splititem.current_balance == "string") {

                    //   let current_balancet_arr = splititem.current_balance.split("$");
                    //   let current_balancet_arr_curen =  current_balancet_arr[1].split(",");
  
                    //       var current_balancet_arr_curencuren = "";
                    //       for ( i = 0; i < current_balancet_arr_curen.length; i++) {
                    //         current_balancet_arr_curencuren += current_balancet_arr_curen[i]; 
                    //       }
  
                    //       splititem.current_balance = parseInt(current_balancet_arr_curencuren)
                      
                    // }
                    // if(typeof splititem.repayments == "string") {

                    //   let repayments_arr = splititem.repayments.split("$");
                    //   let repayments_arr_curen =  repayments_arr[1].split(",");
  
                    //       var repayments_arr_curencuren = "";
                    //       for ( i = 0; i < repayments_arr_curen.length; i++) {
                    //         repayments_arr_curencuren += repayments_arr_curen[i]; 
                    //       }
  
                    //       splititem.repayments = parseInt(repayments_arr_curencuren)
                      
                    // }
                    // if(typeof splititem.mortgage_limit == "string") {

                    //   let mortgage_limit_arr = splititem.mortgage_limit.split("$");
                    //   let mortgage_limit_arr_curen =  mortgage_limit_arr[1].split(",");
  
                    //       var mortgage_limit_arr_curencuren = "";
                    //       for ( i = 0; i < mortgage_limit_arr_curen.length; i++) {
                    //         mortgage_limit_arr_curencuren += mortgage_limit_arr_curen[i]; 
                    //       }
  
                    //       splititem.mortgage_limit = parseInt(mortgage_limit_arr_curencuren)
                      
                    // }

                    // if(typeof splititem.current_balance == "string") {

                    //   let balance_arr = splititem.current_balance.split("$");
                    //   splititem.current_balance =  parseInt(balance_arr[1]);
                      
                    // }

                    // if(typeof splititem.mortgage_limit == "string") {
                    //   let mortgage_arr = splititem.mortgage_limit.split("$");
                    //   splititem.mortgage_limit =  parseInt(mortgage_arr[1]);

                    // }

                    // if(typeof splititem.repayments == "string") {
                    //   let repayments_arr = splititem.repayments.split("$");
                    //   splititem.repayments =  parseInt(repayments_arr[1]);

                    // }
                
                    splits.push(splititem);
                    
                  });
  
                  value.itemRowsMortgageSplits = splits;
                }


              }
              value.created_date = data.created_date
              realestate.push(value);
            })
            console.log(realestate);
            
            // thiss.realestates = data.realestate;
            thiss.realestates = realestate;
            realestate.forEach(function (value, index) {
             
              thiss.showHideLeaderAddressRealestate.push(0);
              thiss.showHideLeaderAssetValueRealestate.push(0);
              thiss.showHideLeaderOwnershipTitleNameRealestate.push(0);
              thiss.showHideLeaderRentAnnualRealestate.push(0);
              thiss.showHideLeaderGrossAmountRealestate.push(0);
              
              thiss.split_current_balance = 0;
              thiss.split_mortgage_limit = parseFloat('0');
              thiss.split_available_redraw = parseFloat('0');
              thiss.split_repayments = parseFloat('0');
              thiss.annual_repayments_limit1 = parseInt('0');
              thiss.annual_repayments_limit2 = parseInt('0');
              thiss.split_interest_rate = parseFloat('0');
  
              if(value.itemRowsMortgageSplits.length > 0){
             
                showHideLeaderCreditorRealestate = [];
                showHideLeaderMortgageLimitRealestate = [];
                showHideLeaderCurrentBalanceRealestate = [];
                showHideLeaderIntrestRateRealestate = [];
                showHideLeaderInterestRateTermRealestate = [];
                showHideLeaderLoanTypeRealestate = [];
                showHideLeaderRepaymentsRealestate = [];
                 value.itemRowsMortgageSplits.forEach(function (value2, key2) {
                  
                 
                  showHideLeaderCreditorRealestate.push(0);
                  showHideLeaderMortgageLimitRealestate.push(0);
                  showHideLeaderCurrentBalanceRealestate.push(0);
                  showHideLeaderIntrestRateRealestate.push(0);
                  showHideLeaderInterestRateTermRealestate.push(0);
                  showHideLeaderLoanTypeRealestate.push(0);
                  showHideLeaderRepaymentsRealestate.push(0);
                 
                  // if(typeof value2.current_balance == "string") {

                  //   let current_arr = value2.current_balance.split("$");
                  //   let split_curen =  current_arr[1].split(",");

                  //       if(split_curen.length > 0) {
                  //         var finalcuren = "";
                  //           for ( i = 0; i < split_curen.length; i++) {
                  //             finalcuren += split_curen[i]; 
                  //           }

                  //         value2.current_balance = parseInt(finalcuren)
                  //       }
                  //       else {
                  //         value2.current_balance =  parseInt(current_arr[1]);
                  //       }
                        
                    
                  // }

                   if(typeof value2.current_balance == "string") {
                  var current_balance= value2.current_balance.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                  //var current_balance = value2.current_balance.replace("$", "");
                  console.log(current_balance);
                  thiss.split_current_balance = (parseFloat(thiss.split_current_balance)+parseFloat(current_balance)).toFixed(2);
                  
                  thiss.split_current_balance = thiss.split_current_balance.replace(/^0+/, '');
                  let new_current_balance = parseFloat(current_balance).toFixed(2);
                  value2.current_balance = "$ "+thiss.formatMoney(new_current_balance);
                 }
                 if(typeof value2.current_balance == "object") {
                   //var current_balance = 0;
                   value2.current_balance = "$ 0.00";
                    current_balance=0.00;
                    thiss.split_current_balance = (parseFloat(thiss.split_current_balance)+parseFloat(current_balance)).toFixed(2);
                    thiss.split_current_balance = thiss.split_current_balance.replace(/^0+/, '');
                 }
                 if(typeof value2.current_balance == "number") {
                  //var current_balance = 0;
                  //value2.current_balance = "$ 0.00";
                   current_balance=value2.current_balance;
                   thiss.split_current_balance = (parseFloat(thiss.split_current_balance)+parseFloat(current_balance)).toFixed(2);
                   thiss.split_current_balance = thiss.split_current_balance.replace(/^0+/, '');
                   let new_current_balance = parseFloat(current_balance).toFixed(2);
                   value2.current_balance = "$ "+thiss.formatMoney(new_current_balance);
                }
                 //number

                 console.log()
                console.log(typeof value2.current_balance);

                  

                  // if(typeof value2.mortgage_limit == "string") {

                  //   let mortgage_arr = value2.mortgage_limit.split("$");
                  //   let mortgage_curen =  mortgage_arr[1].split(",");

                  //     if(mortgage_curen.length > 0) {
                  //       var finalmortgage = "";
                  //       for ( i = 0; i < mortgage_curen.length; i++) {
                  //         finalmortgage += mortgage_curen[i]; 
                  //       }

                  //       value2.mortgage_limit = parseInt(finalmortgage)
                  //     }
                  //     else {
                  //       value2.mortgage_limit = mortgage_arr[1];
                  //     }
                        
                    
                  // }

                  if(typeof value2.mortgage_limit == "string") {
                    var mortgage_limit= value2.mortgage_limit.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                    //var mortgage_limit = value2.mortgage_limit.replace("$", "");
                    thiss.split_mortgage_limit = (parseFloat(thiss.split_mortgage_limit)+parseFloat(mortgage_limit)).toFixed(2);
                  
                    thiss.split_mortgage_limit = thiss.split_mortgage_limit.replace(/^0+/, '');

                    let new_mortage_limit = parseFloat(mortgage_limit).toFixed(2);
                    value2.mortgage_limit = "$ "+thiss.formatMoney(new_mortage_limit);

                   }
                   if(typeof value2.mortgage_limit == "object") {
                    //var current_balance = 0;
                    value2.mortgage_limit = "$ 0.00";
                    mortgage_limit=0.00;
                    thiss.split_mortgage_limit = (parseFloat(thiss.split_mortgage_limit)+parseFloat(mortgage_limit)).toFixed(2);
                    thiss.split_mortgage_limit = thiss.split_mortgage_limit.replace(/^0+/, '');
                  }
                   
                  if(typeof value2.mortgage_limit == "number") {
                    //var current_balance = 0;
                    //value2.current_balance = "$ 0.00";
                      mortgage_limit=value2.mortgage_limit;
                     thiss.split_mortgage_limit = (parseFloat(thiss.split_mortgage_limit)+parseFloat(mortgage_limit)).toFixed(2);
                     thiss.split_mortgage_limit = thiss.split_mortgage_limit.replace(/^0+/, '');
                     let new_mortage_limit = parseFloat(mortgage_limit).toFixed(2);
                     value2.mortgage_limit = "$ "+thiss.formatMoney(new_mortage_limit);
                  }
                  // thiss.split_mortgage_limit += parseFloat((mortgage_limit == undefined) ? 0 : mortgage_limit).toFixed(2);
                  // thiss.split_mortgage_limit = thiss.split_mortgage_limit.replace(/^0+/, '');
                  // if(typeof value2.available_redraw == "string") {

                  //   let redraw_arr = value2.available_redraw.split("$");
                  //   let redraw_curen =  redraw_arr[1].split(",");

                  //     if(redraw_curen.length > 0) {
                  //       var finalredraw = "";
                  //       for ( i = 0; i < redraw_curen.length; i++) {
                  //         finalredraw += redraw_curen[i]; 
                  //       }

                  //       value2.available_redraw = parseInt(finalredraw)
                  //     }
                  //     else {
                  //       value2.available_redraw = redraw_arr[1];
                  //     }
                        
                    
                  // }
                  if(typeof value2.available_redraw == "string") {
                    var available_redraw= value2.available_redraw.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                    //var available_redraw = value2.available_redraw.replace(" $", "");
                    thiss.split_available_redraw = (parseFloat(thiss.split_available_redraw)+parseFloat(available_redraw)).toFixed(2);
                  
                    thiss.split_available_redraw = thiss.split_available_redraw.replace(/^0+/, '');

                    let newavailable_redraw = parseFloat(available_redraw).toFixed(2);
                    value2.available_redraw = "$ "+thiss.formatMoney(newavailable_redraw);

                   }
                   if(typeof value2.available_redraw == "object") {
                    //var current_balance = 0;
                    value2.available_redraw = "$ 0.00";
                    available_redraw=0.00;
                    thiss.split_available_redraw = (parseFloat(thiss.split_available_redraw)+parseFloat(available_redraw)).toFixed(2);
                    thiss.split_available_redraw = thiss.split_available_redraw.replace(/^0+/, '');
                  }
                  if(typeof value2.available_redraw == "number") {
                    //var current_balance = 0;
                    //value2.current_balance = "$ 0.00";
                    available_redraw=value2.available_redraw;
                     thiss.split_available_redraw = (parseFloat(thiss.split_available_redraw)+parseFloat(available_redraw)).toFixed(2);
                     thiss.split_available_redraw = thiss.split_available_redraw.replace(/^0+/, '');
                     let newavailable_redraw = parseFloat(available_redraw).toFixed(2);
                     value2.available_redraw = "$ "+thiss.formatMoney(newavailable_redraw);
                  }
                  // thiss.split_available_redraw += parseFloat((isNaN(available_redraw)) ? available_redraw : available_redraw).toFixed(2);
                  // thiss.split_available_redraw = thiss.split_available_redraw.replace(/^0+/, '');
                   //console.log(thiss.split_available_redraw);
                  // if(typeof value2.repayments == "string") {

                  //   let repayments_arr = value2.repayments.split("$");
                  //   let repayments_curen =  repayments_arr[1].split(",");

                  //     if(repayments_curen.length > 0) {
                  //       var finalrepayments = "";
                  //       for ( i = 0; i < repayments_curen.length; i++) {
                  //         finalrepayments += repayments_curen[i]; 
                  //       }

                  //       value2.repayments = parseInt(finalrepayments)
                  //     }
                  //     else {
                  //       value2.repayments = repayments_arr[1];
                  //     }
                        
                    
                  // }
                  if(typeof value2.repayments == "string") {
                    var repayments= value2.repayments.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                    //var repayments = value2.repayments.replace("$", "");
                    //value2.repayments=parseFloat(repayments);
                    thiss.split_repayments = (parseFloat(thiss.split_repayments)+parseFloat(repayments)).toFixed(2);

                    let newrepayments = parseFloat(repayments).toFixed(2);
                    value2.repayments = "$ "+thiss.formatMoney(newrepayments);
                  
                    thiss.split_repayments = thiss.split_repayments.replace(/^0+/, '');
                    //console.logthis.formatMoney(value2.repayments);
                   }
                   if(typeof value2.repayments == "object") {
                    //var current_balance = 0;
                    value2.repayments = "$ 0.00";
                    repayments=0.00;
                    thiss.split_repayments = (parseFloat(thiss.split_repayments)+parseFloat(repayments)).toFixed(2);
                    thiss.split_repayments = thiss.split_repayments.replace(/^0+/, '');
                  }
                  if(typeof value2.repayments == "number") {
                    //var current_balance = 0;
                    //value2.current_balance = "$ 0.00";
                    repayments=value2.repayments;
                     thiss.split_repayments = (parseFloat(thiss.split_repayments)+parseFloat(repayments)).toFixed(2);
                     thiss.split_repayments = thiss.split_repayments.replace(/^0+/, '');
                     let newrepayments = parseFloat(repayments).toFixed(2);
                     value2.repayments = "$ "+thiss.formatMoney(newrepayments);
                  }
                  if(typeof value2.interest_rate == "object") {
                    //var current_balance = 0;
                    value2.interest_rate = "$ 0.00";
                  }

                   console.log(value2.repayments);
                  // thiss.split_repayments += parseFloat(repayments);
                  thiss.split_interest_rate += parseFloat(value2.interest_rate);
                  thiss.split_creditor = value2.creditor;
                  thiss.split_loan_type = value2.loan_type;
                  thiss.split_interest_rate_term = value2.interest_rate_term;

                  let CB = parseInt(current_balance);
                  let IR = parseFloat(value2.interest_rate);

                  thiss.annual_repayments_limit1 += ((CB)*(IR/100));

                  //thiss.realestates[index].itemRowsMortgageSplits[key2].current_balance = parseFloat(current_balance).toFixed(2);
                  thiss.realestates[index].itemRowsMortgageSplits[key2].mortgage_limit = parseFloat((mortgage_limit == undefined) ? 0 : mortgage_limit).toFixed(2);
                  // thiss.realestates[index].itemRowsMortgageSplits[key2].available_redraw = parseFloat((isNaN(available_redraw)) ? available_redraw : available_redraw).toFixed(2);
                  // thiss.realestates[index].itemRowsMortgageSplits[key2].repayments = parseFloat(repayments).toFixed(2);
                 });

                 console.log('working');
                 
                thiss.realestates[index].creditor = thiss.split_creditor;
                thiss.realestates[index].interest_rate_term = thiss.split_interest_rate_term;
                thiss.realestates[index].loan_type = thiss.split_loan_type;
                thiss.realestates[index].mortgage_limit = thiss.split_mortgage_limit;
                thiss.realestates[index].available_redraw = thiss.split_available_redraw;
                thiss.realestates[index].current_balance = thiss.split_current_balance;
                thiss.realestates[index].repayments = thiss.split_repayments;
                thiss.realestates[index].interest_rate = thiss.split_interest_rate;


                // if(typeof value.asset_value == "string") {

                //   let asset_arr = value.asset_value.split("$");
                //   let asset_curen =  asset_arr[1].split(",");

                //       if( asset_curen.length > 0) {
                //         var finalasset = "";
                //         for ( i = 0; i < asset_curen.length; i++) {
                //           finalasset += asset_curen[i]; 
                //         }
  
                //         value.asset_value = parseInt(finalasset)
                //       }
                //       else {
                //         value.asset_value = asset_arr[1];
                //       }
                      
                  
                // }
                
                 if(typeof value.asset_value == "string") {
                  var asset_value= value.asset_value.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                  asset_value = parseFloat(asset_value).toFixed(2);
                  value.asset_value = '$ '+thiss.formatMoney(asset_value);
                  //var asset_value = value.asset_value.replace("$", "");
                  //value.asset_value=asset_value;
                 }
                 else if(typeof value.asset_value == "number") {
                   asset_value = parseFloat(value.asset_value).toFixed(2);
                  value.asset_value = '$ '+thiss.formatMoney(asset_value);
                }
                 
                //var asset_value = value.asset_value;

                thiss.realestates[index].lvr = ((thiss.split_current_balance/asset_value)*100).toFixed(2);

                thiss.total_current_balance += parseFloat(thiss.split_current_balance);
                // thiss.total_current_balance = thiss.total_current_balance.replace(/^0+/, '');

                thiss.total_mortgage_limit += parseFloat(thiss.split_mortgage_limit).toFixed(2);
                thiss.total_mortgage_limit = thiss.total_mortgage_limit.replace(/^0+/, '');
                
                thiss.total_asset_value += parseFloat(asset_value);
                // thiss.total_asset_value = thiss.total_asset_value.replace(/^0+/, '');
                
                thiss.total_available_redraw += parseFloat(thiss.split_available_redraw);
                // thiss.total_available_redraw = thiss.total_available_redraw.replace(/^0+/, '');
               
                thiss.total_repayments += parseFloat(thiss.split_repayments);
                // thiss.total_repayments = thiss.total_repayments.replace(/^0+/, '');

                // if(typeof value.gross_amount == "string") {

                //   let gross_arr = value.gross_amount.split("$");
                //   let gross_arr_curen =  gross_arr[1].split(",");

                //      if(gross_arr_curen.length > 0) {
                //         var finalgross_arr_curen = "";
                //         for ( i = 0; i < gross_arr_curen.length; i++) {
                //           finalgross_arr_curen += gross_arr_curen[i]; 
                //         }

                //         value.gross_amount = parseInt(finalgross_arr_curen)
                //      }
                //      else {
                //       value.gross_amount = gross_arr[1];
                //      }
                      
                  
                // }


                if(typeof value.gross_amount == "string") {
                  var gross_amount= value.gross_amount.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                  gross_amount = parseFloat(gross_amount).toFixed(2);
                  value.gross_amount = '$ '+thiss.formatMoney(gross_amount);
                  //var gross_amount = value.gross_amount.replace("$", "");
                  //gross_amount=gross_amount;
                }
                else if(typeof value.gross_amount == "number") {
                  gross_amount = parseFloat(value.gross_amount).toFixed(2);
                 value.gross_amount = '$ '+thiss.formatMoney(gross_amount);
               }
                // else {
                //   var gross_amount = value.gross_amount;
                //   value.gross_amount = '$ '+gross_amount;
                // }
                //var gross_amount = value.gross_amount;
                
                value.rent_annual = parseInt(gross_amount)*52;

                thiss.total_gross_amount += parseInt(gross_amount);
                thiss.total_rent_annual += parseInt(gross_amount)*52;
               
                thiss.realestates[index].lvr = ((parseInt(thiss.split_current_balance)/asset_value)*100).toFixed(2);
                thiss.annual_repayments_limit1 = (parseInt(thiss.split_current_balance)*(parseFloat(thiss.split_interest_rate)/100)).toFixed(2);
                thiss.annual_repayments_limit2 = (parseInt(thiss.split_current_balance)*12).toFixed(2);
                if(parseInt(thiss.annual_repayments_limit1) > parseInt(thiss.annual_repayments_limit2)){
                  thiss.total_annual_repayments_limit += parseInt(thiss.annual_repayments_limit1);
                  thiss.realestates[index].annual_repayments_limit = parseInt(thiss.annual_repayments_limit1);
                }else{
                  thiss.total_annual_repayments_limit += parseInt(thiss.annual_repayments_limit2);
                  thiss.realestates[index].annual_repayments_limit = parseInt(thiss.annual_repayments_limit2);
                }
                thiss.total_lvr = parseFloat(((thiss.total_current_balance/thiss.total_asset_value)*100).toFixed(2));
              }
              thiss.showHideLeaderCreditorRealestate.push(showHideLeaderCreditorRealestate);
              thiss.showHideLeaderMortgageLimitRealestate.push(showHideLeaderMortgageLimitRealestate);
              thiss.showHideLeaderCurrentBalanceRealestate.push(showHideLeaderCurrentBalanceRealestate);
              thiss.showHideLeaderIntrestRateRealestate.push(showHideLeaderIntrestRateRealestate);
              thiss.showHideLeaderInterestRateTermRealestate.push(showHideLeaderInterestRateTermRealestate);
              thiss.showHideLeaderLoanTypeRealestate.push(showHideLeaderLoanTypeRealestate);
              thiss.showHideLeaderRepaymentsRealestate.push(showHideLeaderRepaymentsRealestate);
             });

             console.log(data.realestate);
             debugger;
          }

        }
        


        if (data.contacts !== undefined) {
          if(data.contacts[0].contact_details.employment_details) {
            thiss.incomes = data.contacts[0].contact_details.employment_details.incomes;
          }
          else {
            thiss.incomes = [];
          }
          
        }
        

        if (data.assets !== undefined) {
          thiss.assets = data.assets;

          thiss.assets.forEach(assetelemt => {

            if(typeof assetelemt.percentage_asset == "string") {

              assetelemt.percentage_asset = parseInt(assetelemt.percentage_asset.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, ''));
              
            }
            if(typeof assetelemt.percentage_asset_0 == "string") {
              assetelemt.percentage_asset_0 = parseInt(assetelemt.percentage_asset_0.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, ''));
            }
            if(typeof assetelemt.percentage_asset_1 == "string") {
              assetelemt.percentage_asset_1 = parseInt(assetelemt.percentage_asset_1.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, ''));
            }
            if(typeof assetelemt.percentage_asset_2 == "string") {
              assetelemt.percentage_asset_2 = parseInt(assetelemt.percentage_asset_2.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, ''));
            }
            if(typeof assetelemt.percentage_asset_3 == "string") {
              assetelemt.percentage_asset_3 = parseInt(assetelemt.percentage_asset_3.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, ''));
            }
            if(typeof assetelemt.percentage_asset_4 == "string") {
              assetelemt.percentage_asset_4 = parseInt(assetelemt.percentage_asset_4.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, ''));
            }
            
          });


        }
        else {
          thiss.assets = [];
        }

        if (data.liabilities !== undefined) {
          console.log('liabilities',data.liabilities)

          data.liabilities.forEach(liabilitelement => {

              if(liabilitelement.owner) {
                // if(typeof liabilitelement.owner == "string") {

                //     if(liabilitelement.owner == '') {
                //       liabilitelement.owner = 'primary';
                //     }
                //     else {
                //       liabilitelement.owner = parseInt(liabilitelement.owner);
                //     }
                  
                // }
              }
              else {
                liabilitelement.owner = 'primary';
              }

          });

          thiss.liabilities = data.liabilities;
        }
        console.log(thiss.secondary_applicant);

        let reference_broker = data.reference_broker;
        if (reference_broker == "" || reference_broker == null || reference_broker == undefined) { } else {
          thiss.getBrokerDetails(reference_broker).subscribe((brokerDetails) => {
            if (brokerDetails.length > 0) {
            
              thiss.assigned_broker_name = brokerDetails[0].firstname + ' ' + brokerDetails[0].lastname;
            } else {
              thiss.assigned_broker_name = 'Broker not assigned';
            }
          });
        }

        for (var i = 0; i < data.contacts.length; i++) {
          if(data.contacts[i].type!=undefined){
            if (data.contacts[i].type == 'primary') {
             
              thiss.user_data.email = data.contacts[i].user_data.email;
              thiss.user_data.mobile_phone = data.contacts[i].user_data.mobile_phone;
              thiss.user_data.firstname = data.contacts[i].user_data.firstname;
              thiss.user_data.middlename = data.contacts[i].user_data.middlename;
              thiss.user_data.lastname = data.contacts[i].user_data.lastname;
              thiss.user_data.date_of_birth = data.contacts[i].user_data.date_of_birth;

              // if (uid == data.contacts[i].user_data.uid) {
              //   thiss.userAccessEdit = (data.contacts[i].user_data.allowCustoeditPermission == undefined) ? 0 : data.contacts[i].user_data.allowCustoeditPermission;
              //   thiss.userAccessView = (data.contacts[i].user_data.allowCustoViewOnlyPermission == undefined) ? 0 : data.contacts[i].user_data.allowCustoViewOnlyPermission;
              // }

              if(data.contacts[i].contact_details.address) {
                thiss.user_data.housing_situation = data.contacts[i].contact_details.address[0].housing_situation;
              thiss.user_data.poboxlabel = data.contacts[i].contact_details.address[0].poboxlabel;
              thiss.user_data.floor_number = data.contacts[i].contact_details.address[0].floor_number;
              thiss.user_data.unit_number = data.contacts[i].contact_details.address[0].unit_number;
              thiss.user_data.building_name = data.contacts[i].contact_details.address[0].building_name;
              thiss.user_data.street_number = data.contacts[i].contact_details.address[0].street_number;
              thiss.user_data.street_name = data.contacts[i].contact_details.address[0].street_name;
              thiss.user_data.city = data.contacts[i].contact_details.address[0].city;
              thiss.user_data.state = data.contacts[i].contact_details.address[0].state;
              thiss.user_data.country = data.contacts[i].contact_details.address[0].country;
              thiss.user_data.postcode = data.contacts[i].contact_details.address[0].postcode;
              thiss.user_data.gender = data.contacts[i].contact_details.dependent.gender;
              thiss.user_data.current_marital_status = data.contacts[i].contact_details.dependent.current_marital_status;
              thiss.user_data.how_many_children = data.contacts[i].contact_details.dependent.how_many_children;
              if (data.contacts[i].contact_details.dependent.how_many_children >= 1) {
                thiss.user_data.first_child_age = data.contacts[i].contact_details.dependent.children_age[0].age;
              }
              if (data.contacts[i].contact_details.dependent.how_many_children >= 2) {
                thiss.user_data.second_child_age = data.contacts[i].contact_details.dependent.children_age[1].age;
              }
              if (data.contacts[i].contact_details.dependent.how_many_children >= 3) {
                thiss.user_data.third_child_age = data.contacts[i].contact_details.dependent.children_age[2].age;
              }
              if (data.contacts[i].contact_details.dependent.how_many_children >= 4) {
                thiss.user_data.fourth_child_age = data.contacts[i].contact_details.dependent.children_age[3].age;
              }
              if (data.contacts[i].contact_details.dependent.how_many_children >= 5) {
                thiss.user_data.fifth_child_age = data.contacts[i].contact_details.dependent.children_age[4].age;
              }
              if (data.contacts[i].contact_details.dependent.how_many_children >= 6) {
                thiss.user_data.sixth_child_age = data.contacts[i].contact_details.dependent.children_age[5].age;
              }
              thiss.employment = data.contacts[i].contact_details.employment_details;
              }
              

              
            } else if(data.contacts[i].type == 'additional') {
              //thiss.secondary_applicant = [];

              // if (uid == data.contacts[i].user_data.uid) {
              //   thiss.userAccessEdit = (data.contacts[i].user_data.allowCustoeditPermission == undefined) ? 0 : data.contacts[i].user_data.allowCustoeditPermission;
              //   thiss.userAccessView = (data.contacts[i].user_data.allowCustoViewOnlyPermission == undefined) ? 0 : data.contacts[i].user_data.allowCustoViewOnlyPermission;
              // }

              thiss.secondary_applicant.push(data.contacts[i]);
              thiss.secondary_applicant_load = true;
            }
          }else{

            if(data.contacts[i].contact_details.address) {
              thiss.user_data.email = data.contacts[0].user_data.email;
              thiss.user_data.mobile_phone = data.contacts[0].user_data.mobile_phone;
              thiss.user_data.firstname = data.contacts[0].user_data.firstname;
              thiss.user_data.middlename = data.contacts[0].user_data.middlename;
              thiss.user_data.lastname = data.contacts[0].user_data.lastname;
              thiss.user_data.date_of_birth = data.contacts[0].user_data.date_of_birth;
              thiss.user_data.housing_situation = data.contacts[0].contact_details.address[0].housing_situation;
              thiss.user_data.poboxlabel = data.contacts[0].contact_details.address[0].poboxlabel;
              thiss.user_data.floor_number = data.contacts[0].contact_details.address[0].floor_number;
              thiss.user_data.unit_number = data.contacts[0].contact_details.address[0].unit_number;
              thiss.user_data.building_name = data.contacts[0].contact_details.address[0].building_name;
              thiss.user_data.street_number = data.contacts[0].contact_details.address[0].street_number;
              thiss.user_data.street_name = data.contacts[0].contact_details.address[0].street_name;
              thiss.user_data.city = data.contacts[0].contact_details.address[0].city;
              thiss.user_data.state = data.contacts[0].contact_details.address[0].state;
              thiss.user_data.country = data.contacts[0].contact_details.address[0].country;
              thiss.user_data.postcode = data.contacts[0].contact_details.address[0].postcode;
              thiss.user_data.gender = data.contacts[0].contact_details.dependent.gender;
              thiss.user_data.current_marital_status = data.contacts[0].contact_details.dependent.current_marital_status;
              thiss.user_data.how_many_children = data.contacts[0].contact_details.dependent.how_many_children;
              if (data.contacts[0].contact_details.dependent.how_many_children >= 1) {
                thiss.user_data.first_child_age = data.contacts[0].contact_details.dependent.children_age[0].age;
              }
              if (data.contacts[0].contact_details.dependent.how_many_children >= 2) {
                thiss.user_data.second_child_age = data.contacts[0].contact_details.dependent.children_age[1].age;
              }
              if (data.contacts[0].contact_details.dependent.how_many_children >= 3) {
                thiss.user_data.third_child_age = data.contacts[0].contact_details.dependent.children_age[2].age;
              }
              if (data.contacts[0].contact_details.dependent.how_many_children >= 4) {
                thiss.user_data.fourth_child_age = data.contacts[0].contact_details.dependent.children_age[3].age;
              }
              if (data.contacts[0].contact_details.dependent.how_many_children >= 5) {
                thiss.user_data.fifth_child_age = data.contacts[0].contact_details.dependent.children_age[4].age;
              }
              if (data.contacts[0].contact_details.dependent.how_many_children >= 6) {
                thiss.user_data.sixth_child_age = data.contacts[0].contact_details.dependent.children_age[5].age;
              }
            }
             
              //thiss.employment = data.contacts[0].contact_details.employment_details;
          }
          debugger;
         
        }

      });



    }

    

    this.showDetails = true;
    this.icon = 'ios-remove-circle-outline';

    this.updateEmailPhoneForm = formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.minLength(10), Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.minLength(10), Validators.maxLength(10), Validators.required])],
      edit_con_uid: ['']
    });

    this.updateEmailPhoneFormSec = formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.minLength(10), Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.minLength(10), Validators.maxLength(10), Validators.required])],
      edit_con_uid: ['']
    })

  }

  AddupdateEmailPhone(event, contact_id, form) {
    let userForm = form;
    debugger;
    if (!userForm.valid) {

      userForm.get('email').markAsDirty();
      userForm.get('email').markAsTouched();

      userForm.get('mobile_phone').markAsDirty();
      userForm.get('mobile_phone').markAsTouched();

    } else {

      this.loadingProvider.startLoading();
      let email = userForm.value.email;
      let mobile_phone = userForm.value.mobile_phone;
      
      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');
      const requestOptions = new RequestOptions({ headers: headers });
      let postData = {
        "email": email,
        "phoneNumber": "+6" + mobile_phone,
        "mobile_phone": mobile_phone,
        "contact_id": contact_id
      }
      var url = this.EnvDataService.EnvData.sendbox_api + "/updateViewPageAdfDetails";
      this.http.post(url, postData, requestOptions)
        .subscribe(data => {
          if (data['_body'] == 'The email address is already in use by another account.') {
            this.presentToast(data['_body']);
          } else if (data['_body'] == 'The user with the provided phone number already exists.') {
            this.presentToast(data['_body']);
          } else if (data['_body'] == 'TOO_LONG') {
            this.presentToast('Invalid Phone Number.');
          } else if (data['_body'] == 'TOO_SHORT') {
            this.presentToast('Invalid Phone Number.');
          } else if (data['_body'] == 'Invalid format.') {
            this.presentToast('Invalid Phone Number.');
          } else if (data['_body'] == 'The phone number must be a non-empty E.164 standard compliant identifier string.') {
            this.presentToast('Invalid Phone Number.');
          } else {
            this.editEmailOption = 0;
            this.editPhoneOption = 0;
            this.editEmailOptionSecond = 0;
            this.editPhoneOptionSecond = 0;
            if (email != "") {
              
              this.primSecondContact.email = email;
            //   if (userType == 'primary') {
            //     this.user_data.email = email;
            //   } else if (userType == 'secondary') {
            //     this.primSecondContact.email = email;
            //   }
             }
             if (mobile_phone != "") {
              this.primSecondContact.mobile_phone = mobile_phone;
            //   if (userType == 'primary') {
            //     this.user_data.mobile_phone = mobile_phone;
            //   } else if (userType == 'secondary') {
            //     this.primSecondContact.mobile_phone = mobile_phone;
            //   }
             }
          }
          this.loadingProvider.stopLoading();
        }, error => {
          this.loadingProvider.stopLoading();
          this.presentToast(error.message);
        });
    }
  }

  updateEmailPhone(contact_id, form, userType) {
    let userForm = form;
    debugger;
    if (!userForm.valid) {

      userForm.get('email').markAsDirty();
      userForm.get('email').markAsTouched();

      userForm.get('mobile_phone').markAsDirty();
      userForm.get('mobile_phone').markAsTouched();

    } else {

      this.loadingProvider.startLoading();
      let email = userForm.value.email;
      let mobile_phone = userForm.value.mobile_phone;
      
      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');
      const requestOptions = new RequestOptions({ headers: headers });
      let postData = {
        "email": email,
        "phoneNumber": "+6" + mobile_phone,
        "mobile_phone": mobile_phone,
        "contact_id": this.primary_contact_id
      }
      var url = this.EnvDataService.EnvData.sendbox_api + "/updateViewPageContactDetails";
      this.http.post(url, postData, requestOptions)
        .subscribe(data => {
          if (data['_body'] == 'The email address is already in use by another account.') {
            this.presentToast(data['_body']);
          } else if (data['_body'] == 'The user with the provided phone number already exists.') {
            this.presentToast(data['_body']);
          } else if (data['_body'] == 'TOO_LONG') {
            this.presentToast('Invalid Phone Number.');
          } else if (data['_body'] == 'TOO_SHORT') {
            this.presentToast('Invalid Phone Number.');
          } else if (data['_body'] == 'Invalid format.') {
            this.presentToast('Invalid Phone Number.');
          } else if (data['_body'] == 'The phone number must be a non-empty E.164 standard compliant identifier string.') {
            this.presentToast('Invalid Phone Number.');
          } else {
            this.editEmailOption = 0;
            this.editPhoneOption = 0;
            this.editEmailOptionSecond = 0;
            this.editPhoneOptionSecond = 0;
            if (email != "") {
              if (userType == 'primary') {
                this.user_data.email = email;
              } else if (userType == 'secondary') {
                this.primSecondContact.email = email;
              }
            }
            if (mobile_phone != "") {
              if (userType == 'primary') {
                this.user_data.mobile_phone = mobile_phone;
              } else if (userType == 'secondary') {
                this.primSecondContact.mobile_phone = mobile_phone;
              }
            }
          }
          this.loadingProvider.stopLoading();
        }, error => {
          this.loadingProvider.stopLoading();
          this.presentToast(error.message);
        });
    }
  }

  getBrokerDetails(reference_broker) {
    return this.db.collection<any>("users", ref => ref.where('uid', '==', reference_broker).where('deleted', '<', 1)).valueChanges();
  }

  


  viewContactPDF(event, contact_uid, t_document_id, SDF_form_document_id) {
    debugger;
    this.navCtrl.push(ViewContactPdfPage, {
      contact_uid: this.contact_uid,
      t_document_id: t_document_id,
      SDF_form_document_id: this.SDF_form_document_id
    });
  }


  viewSingleAssets(i, type) {
    if (type == 'asset') {
      if (this.assets[i].show == 1) {
        this.assets[i].show = 0;
      } else {
        this.assets[i].show = 1;
      }
    } else if (type == 'liability') {
      if (this.liabilities[i].show == 1) {
        this.liabilities[i].show = 0;
      } else {
        this.liabilities[i].show = 1;
      }
    } 
    // else if (type == 'income') {
    //   if (this.incomes[i].show == 1) {
    //     this.contact.contact_details.employment_details.incomes[i].show = 0;
    //   } else {
    //     this.contact.contact_details.employment_details.incomes[i].show = 1;
    //   }
    // }
  }

  viewSingleIncomeAssets(i, type,ii) {
    debugger;
    if (this.user_data.contacts[i].contact_details.employment_details.incomes[ii].show == 1) {
      this.user_data.contacts[i].contact_details.employment_details.incomes[ii].show = 0;
    } else {
      this.user_data.contacts[i].contact_details.employment_details.incomes[ii].show = 1;
    }
    console.log(this.user_data);
  }

  editTentativeRealEstateByGroup(event, contact_uid, group_id, SDF_form_document_id) {
    window.localStorage.removeItem("generate_new_tentative");
    let primary_id = '';
    let secondary_id = '';
    if (this.primary_secondary_found == "Primary") {
      secondary_id = this.primary_secondary_contact_uid;
      primary_id = this.contact_uid;
    } else {
      primary_id = this.primary_secondary_contact_uid;
      secondary_id = this.contact_uid;
    }
    if (secondary_id == undefined) {
      secondary_id = '';
    }
    window.localStorage.setItem("contact_uid", primary_id);
    window.localStorage.setItem("contact_second_uid", secondary_id);
    this.navCtrl.push(TentativeRealEstateAssetPage, {
      edit_contact_uid: primary_id,
      second_contact_id: secondary_id,
      group_id: group_id,
      SDF_form_document_id: SDF_form_document_id
    });
  }

  sendEmailtoCustomerWithTentative(event, contact_uid, t_document_id) {
    this.loadingProvider.startLoading();
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json');
    const requestOptions = new RequestOptions({ headers: headers });
    let postData = {
      'contact_uid': contact_uid,
      'document_id': t_document_id
    }
    var url = this.EnvDataService.EnvData.sendbox_api + "/sendEmailtoCustomerWithTentative";
    this.http.post(url, postData, requestOptions)
      .subscribe(data => {
        this.loadingProvider.stopLoading();
        if (data['_body'] == 'success') {
          this.presentToast('Email sent successfully.');
        } else {
          this.presentToast('Something went wrong please try again later.');
        }
      }, error => {
        this.loadingProvider.stopLoading();
      });
  }

  permissionToUser(event, contact_uid, allowCustoeditPermission, allowCustoViewOnlyPermission, SDF_form_document_id) {

    debugger;
   
    // let editMenu = this.popoverCtrl.create(AllowCustomerPermissionPage, { contact_uid: contact_uid, allowCustoeditPermission: allowCustoeditPermission, allowCustoViewOnlyPermission: allowCustoViewOnlyPermission, SDF_form_document_id: SDF_form_document_id }, { showBackdrop: true, cssClass: 'popOverClass' });
    // editMenu.present({
    //   ev: event
    // });
    console.log(this.user_data);

    

    //if(this.user_data.)

    // allowCustoeditPermission = this.userAccessEdit;
    // allowCustoViewOnlyPermission = this.userAccessView;
    contact_uid = this.primary_contact_id;
    SDF_form_document_id = this.user_data.adf_form_id;
    let reference_broker_uid = this.adf_data.reference_broker;
    let customer_email:any;
    let customer_password :any; 
    let broker_email:any;
    let firstname:any;
    
    //allowCustoViewOnlyPermission = this.userAccessView;
    if(!this.adf_flag) {
      this.adf_data.contacts.forEach(contact => {

        if(contact.type == 'primary') {
          customer_email = contact.user_data.email;
          contact_uid = contact.user_data.uid;
          customer_password = contact.user_data.password;
          firstname = contact.user_data.firstname;
          allowCustoeditPermission = contact.user_data.allowCustoeditPermission;
          allowCustoViewOnlyPermission = contact.user_data.allowCustoViewOnlyPermission;
        }
      });
    }
    else {
      this.adf_data.contacts.forEach(contact => {

          if(contact.type == 'primary') {
            customer_email = contact.user_data.email;
            contact_uid = contact.user_data.uid;
            customer_password = contact.user_data.password;
            firstname = contact.user_data.firstname;
            allowCustoeditPermission = this.adf_flag.allowCustoeditPermission;
            allowCustoViewOnlyPermission = this.adf_flag.allowCustoViewOnlyPermission;
          }
      });
    }
  

    
    this.ADFFormService.getUsersDataByUser(reference_broker_uid).then((data:any)=>{
      console.log(data)
      broker_email = data.email;
      debugger;

      let editMenu = this.popoverCtrl.create(AdfCustomerPermissionPage, { 
        contact_uid: contact_uid, 
        allowCustoeditPermission: allowCustoeditPermission, 
        allowCustoViewOnlyPermission: allowCustoViewOnlyPermission, 
        SDF_form_document_id: SDF_form_document_id,
        customer_email:customer_email,
        customer_password:customer_password,
        broker_email:broker_email,
        firstname:firstname,
      }, { showBackdrop: true, cssClass: 'popOverClass' });
      editMenu.present({
        ev: event
      });
      editMenu.onDidDismiss((data) => {
        //alert('working');
        this.adf_flag = data;
        // let contacts = [];
        // console.log(data);
        // this.adf_data.contacts.forEach(contact => {

        //   if(contact.type == 'primary') {
        //       contact.allowCustoeditPermission = data.allowCustoeditPermission;
        //       contact.allowCustoViewOnlyPermission = data.allowCustoViewOnlyPermission;
        //     }
        //     contacts.push(contact);
        // });
        //   this.adf_data.contacts = contacts;
      })
      

    })
 

  }

  additionpermissionToUser(event,user_id) {
    debugger;
    console.log(this.adf_data);
  //  let allowCustoeditPermission = this.userAccessEdit;
  //  let allowCustoViewOnlyPermission = this.userAccessView;
   let contact_uid = this.primary_contact_id;
   let SDF_form_document_id = this.user_data.adf_form_id;
    let reference_broker_uid = this.adf_data.reference_broker;
    let customer_email:any;
    let customer_password :any; 
    let broker_email:any;
    let firstname:any;
    let allowCustoeditPermission:any;
    let allowCustoViewOnlyPermission:any;

    if(!this.additionaladf_flag) {
        this.adf_data.contacts.forEach(contact => {

          if(contact.user_data.uid == user_id) {
            customer_email = contact.user_data.email;
            customer_password = contact.user_data.password;
            contact_uid = contact.user_data.uid;
            firstname = contact.user_data.firstname;
            allowCustoeditPermission = contact.user_data.allowCustoeditPermission;
            allowCustoViewOnlyPermission = contact.user_data.allowCustoViewOnlyPermission;
          }
      });
    }
    else {
      this.adf_data.contacts.forEach(contact => {

        if(contact.user_data.uid == user_id) {

          if(contact.user_data.uid == this.additionaladf_flag.contact_uid) {

            customer_email = contact.user_data.email;
            customer_password = contact.user_data.password;
            contact_uid = contact.user_data.uid;
            firstname = contact.user_data.firstname;
            allowCustoeditPermission = this.additionaladf_flag.allowCustoeditPermission;
            allowCustoViewOnlyPermission = this.additionaladf_flag.allowCustoViewOnlyPermission;

          }
          else {
            customer_email = contact.user_data.email;
            customer_password = contact.user_data.password;
            contact_uid = contact.user_data.uid;
            firstname = contact.user_data.firstname;
            allowCustoeditPermission = contact.user_data.allowCustoeditPermission;
            allowCustoViewOnlyPermission = contact.user_data.allowCustoViewOnlyPermission;
          }
        }
    });
    }
  
    this.ADFFormService.getUsersDataByUser(reference_broker_uid).then((data:any)=>{
      console.log(data)
      broker_email = data.email;
      debugger;

      let editMenu = this.popoverCtrl.create(AdfCustomerPermissionPage, { 
        contact_uid: contact_uid, 
        allowCustoeditPermission: allowCustoeditPermission, 
        allowCustoViewOnlyPermission: allowCustoViewOnlyPermission, 
        SDF_form_document_id: SDF_form_document_id,
        customer_email:customer_email,
        customer_password:customer_password,
        broker_email:broker_email,
        firstname:firstname,
      }, { showBackdrop: true, cssClass: 'popOverClass' });
      editMenu.present({
        ev: event
      });

      editMenu.onDidDismiss((data) => {
        //alert('working');
        this.additionaladf_flag = data;
        this.additionaladf_flag.contact_uid = user_id
      })

    })
  }

  showContactDetail(user_id) {
    debugger;
    console.log(user_id);
    this.navCtrl.push(ShowContactForm,{
      contact_uid:this.primary_contact_id,
    });
  }
  showadContactDetail(event,user_id) {
    debugger;
    console.log(user_id);
    this.navCtrl.push(ShowContactForm,{
      contact_uid:user_id,
    });
  }

  accessToUser(event, contact_uid, accessPermission, nextAccess) {
    this.loadingProvider.startLoading();
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json');
    const requestOptions = new RequestOptions({ headers: headers });
    this.accessPermissionStatus = 0;
    if (accessPermission == 0) {
      this.accessPermissionStatus = 1;
    }
    let postData = {
      'contact_uid': contact_uid,
      'accessPermission': this.accessPermissionStatus
    }
    var url = this.EnvDataService.EnvData.sendbox_api + "/sendEmailtoCustomer";
    this.http.post(url, postData, requestOptions)
      .subscribe(data => {
        if (data['_body'] == 'success') {
          if (this.accessPermissionStatus == 1) {
            if (nextAccess == "yes") {
              this.accessPermissioncheckstatusPS = 'ios-lock-outline';
              this.accessPermissionnamePS = 'Allow Customer Access';
            } else {
              this.accessPermissioncheckstatus = 'ios-unlock-outline';
              this.accessPermissionname = 'Disallow Customer Access';
            }
            this.presentToast('Allow access to customer.');
          } else {
            if (nextAccess == "yes") {
              this.accessPermissioncheckstatusPS = 'ios-lock-outline';
              this.accessPermissionnamePS = 'Allow Customer Access';
            } else {
              this.accessPermissioncheckstatus = 'ios-lock-outline';
              this.accessPermissionname = 'Allow Customer Access';
            }
            this.presentToast('Disallow access to customer.');
          }
        } else {
          this.presentToast('Something went wrong please try again later.');
        }
        this.loadingProvider.stopLoading();
      }, error => {
        this.loadingProvider.stopLoading();
      });
  }


  accessGrantedFromUserBySubmit(event, contact_uid, broker_uid, email, name, main_contact_uid, secondary_contact_uid) {
    debugger;
    this.loadingProvider.startLoading();
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json');
    const requestOptions = new RequestOptions({ headers: headers });
    let postData = {
      'contact_uid': contact_uid,
      'broker_uid': broker_uid,
      'email': email,
      'name': name,
      "created_date": new Date().getTime(),
      "contact_type": this.user_data.contact_type,
      "user_history_created_by": contact_uid,
      "SDF_form_document_id": this.SDF_form_document_id
    }
    var url = this.EnvDataService.EnvData.sendbox_api + "/accessGrantedFromUser";
    this.http.post(url, postData, requestOptions)
      .subscribe(data => {
        if (data['_body'] == 'error') {
          this.presentToast('Something went wrong please try again later.');
        } else {
          this.presentToast('Approved Successfully.');
          this.accessGrantedFromUserstatus = 1;
          this.user_data.allowCustoeditPermission = 0;
          this.user_data.allowCustoViewOnlyPermission = 1;
          postData['ip_address'] = data['_body'];
          postData['status'] = 4;
          this.user_history_data(postData)
        }
        this.loadingProvider.stopLoading();
      }, error => {
        this.presentToast(error.message);
        this.loadingProvider.stopLoading();
      });
  }

  accessGrantedFromAdfUserBySubmit(event, contact_uid, broker_uid, email, name, main_contact_uid, secondary_contact_uid) {
    debugger;
    this.loadingProvider.startLoading();
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json');
    const requestOptions = new RequestOptions({ headers: headers });

    name = this.contact_user_data.firstname+' '+this.contact_user_data.lastname;
    let contact_type;

    if(this.adf_data.primary_contact_id == contact_uid) {
        contact_type = 'Primary Applicant'
    }
    else {
      contact_type = 'Additional Applicant'
    }

    console.log(contact_type);

    let postData = {
      'contact_uid': contact_uid,
      'broker_uid': broker_uid,
      'email': this.contact_user_data.email,
      'name': name,
      "created_date": new Date().getTime(),
      "contact_type": contact_type,
      "user_history_created_by": contact_uid,
      "SDF_form_document_id": this.SDF_form_document_id
    }
    var url = this.EnvDataService.EnvData.sendbox_api + "/accessGrantedFromAdfUser";
    this.http.post(url, postData, requestOptions)
      .subscribe(data => {
        if (data['_body'] == 'error') {
          this.presentToast('Something went wrong please try again later.');
        } else {
          this.presentToast('Approved Successfully.');
          this.accessGrantedFromUserstatus = 1;
          //this.user_data.allowCustoeditPermission = 0;
          this.userAccessEdit=0;
          this.userAccessView=1;
          //this.user_data.allowCustoViewOnlyPermission = 1;
          postData['ip_address'] = data['_body'];
          postData['status'] = 4;
          this.user_history_data(postData)
        }
        this.loadingProvider.stopLoading();
      }, error => {
        this.presentToast(error.message);
        this.loadingProvider.stopLoading();
      });
  }

  user_history_data(postData) {
    const user_history = this.db.collection('/user_history');
    user_history.doc(postData.contact_uid + '_' + postData.created_date).set({
      created_date: postData.created_date,
      contact_uid: postData.contact_uid,
      document_id: postData.contact_uid + '_' + postData.created_date,
      ip_address: postData.ip_address,
      uid: postData.user_history_created_by,
      //contact_type: postData.contact_type,
      name: postData.name,
      status: postData.status,
      deleted: 0
    }).then(function () {

    }).catch(function (error) {

    });
  }

  accessGrantedFromUser(event, contact_uid, broker_uid, email, name) {
    this.loadingProvider.startLoading();
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json');
    const requestOptions = new RequestOptions({ headers: headers });
    let postData = {
      'contact_uid': contact_uid,
      'broker_uid': broker_uid,
      'email': email,
      'name': name
    }
    var url = this.EnvDataService.EnvData.sendbox_api + "/accessGrantedFromUser";
    this.http.post(url, postData, requestOptions)
      .subscribe(data => {
        if (data['_body'] == 'success') {
          this.presentToast('Approved Successfully.');
          this.accessGrantedFromUserstatus = 1;
        } else {
          this.presentToast('Something went wrong please try again later.');
        }
        this.loadingProvider.stopLoading();
      }, error => {
        this.presentToast(error.message);
        this.loadingProvider.stopLoading();
      });
  }

  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {

    // console.log(amount);
    //debugger;
    if(Math.ceil(parseFloat(amount)) === amount) {
      console.log(amount);
      try {
        decimalCount = Math.abs(decimalCount);
        // var decimalvalue = amount - Math.floor(amount);
        // console.log(decimalvalue);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
        const negativeSign = amount < 0 ? "-" : "";
  
        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;
  
        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
      } catch (e) {
      
      }
    }
    else if (amount)
    {
      if(!isNaN(amount) && amount.toString().indexOf('.') != -1){
        console.log(amount);
        console.log('yes');
        const pieces = parseFloat(amount).toFixed(2).split('')
        let ii = pieces.length - 3
        while ((ii-=3) > 0) {
          pieces.splice(ii, 0, ',')
        }
        return pieces.join('')
      }
      
    }​
    else {
      return 0;
    }
    //debugger;
    
  }

  formatAmount(amount, decimalCount = 2, decimal = ".", thousands = ",") {

    if(typeof amount == "string") {

      let amnt_arr = amount.split("$");
      amount =  amnt_arr[1];
      //debugger;
      return amount;
      
    }
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
    } catch (e) {
    
    }

  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  popupAction(event: any, contact_uid: any, SDF_form_document_id: any, contact_type: any) {
    let editMenu = this.popoverCtrl.create(EditPopoverPage, { contact_uid: contact_uid, view_contact: 'yes', SDF_form_document_id: SDF_form_document_id, contact_type: contact_type }, { showBackdrop: true, cssClass: 'popOverClass' });
    editMenu.present({
      ev: event
    });

    editMenu.onDidDismiss(data => {
      if (data == "" || data == null || data == undefined) { } else {
        if (data.type == 'viewcontact') {
          let contact_uid = data.contact_uid;
          this.navCtrl.push(ViewAdfPage, {
            contact_uid: contact_uid,
            SDF_form_document_id: SDF_form_document_id
          });
        } else if (data.type == 'editcontact') {
          let contact_uid = data.contact_uid;
          this.navCtrl.push(StepformPage, {
            edit_contact_uid: contact_uid,
            SDF_form_document_id: SDF_form_document_id
          });
        } else if (data.type == 'addsecondary') {
          window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
          window.localStorage.setItem("creating_second", 'yes');
          this.navCtrl.push(StepformPage);
        } else if (data.type == 'realestate') {
          window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
          window.localStorage.setItem("contact_second_uid", data.second_contact_id);
          window.localStorage.setItem("SDF_form_document_id", data.SDF_form_document_id);
          this.navCtrl.push(RealEstatePage, {
            edit_contact_uid: data.contact_id_add_real_estate,
            second_contact_id: data.second_contact_id,
            SDF_form_document_id: data.SDF_form_document_id
          });
          window.localStorage.setItem("generate_new_tentative", '1');
        } else if (data.type == 'tentativerealestate') {
          window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
          window.localStorage.setItem("contact_second_uid", data.second_contact_id);
          window.localStorage.setItem("SDF_form_document_id", data.SDF_form_document_id);
          this.navCtrl.push(TentativeRealEstateAssetPage, {
            edit_contact_uid: data.contact_id_add_real_estate,
            second_contact_id: data.second_contact_id,
            SDF_form_document_id: data.SDF_form_document_id
          });
          window.localStorage.setItem("generate_new_tentative", '1');
        } else if (data.type == 'changelog') {
          let contact_uid = data.contact_uid;
          this.navCtrl.push(ChangeLogProfilePage, {
            contact_uid: contact_uid
          });
        } else if (data.type == 'syncMercury') {
          this.syncInMercury('', data.userData, '', data.userData.accessGrantedFromUser);
        }
      }
    });
  }

  syncInMercury(event, contact_data, reference_broker = '', accessGrantedFromUser = 0) {
    let popUpTitle = 'Confirm Sync contact';
    let popUpDesc = 'Are you sure you want to sync contact with mercury?';
    let popUpCheckbox = [];
    if (accessGrantedFromUser != 1) {
      popUpCheckbox = [{
        name: "name",
        type: "checkbox",
        label: "The contact details are not approved. Please confirm before continue."
      }];
     
    }

    this.assets_data = '';
    this.liabilities_data = '';
    this.realEstate_data = '';
    let alert = this.alertCtrl.create({
      title: popUpTitle,
      subTitle: popUpDesc,
    
      inputs: popUpCheckbox,
      cssClass: 'alertDanger',
      buttons: [
        {
          text: 'No',
          handler: () => {
         
          }
        },
        {
          text: 'Yes',
          handler: () => {
            if (accessGrantedFromUser != 1) {
              if (alert.data.inputs[0].checked == false) {
                alert.setMessage('Please confirm before continue.');
                return false;
              }
            }

            if (contact_data) {
              this.loadingProvider.startLoading();

              this.getBrokerCredentail(contact_data.reference_broker).subscribe((broker_data) => {
                if (broker_data.length > 0) {
                  this.getEmployments(contact_data.uid).subscribe((employment_data) => {
                    this.getAllAssetss(contact_data.uid).subscribe((assets_data) => {
                      this.assets_data = assets_data;
                    });
                    this.getAllLiabilitiess(contact_data.uid).subscribe((liabilities_data) => {
                      this.liabilities_data = liabilities_data;
                    });

                    this.getAllrealEstate(contact_data.uid).subscribe((realEstate_data) => {
                      this.realEstate_data = realEstate_data;
                    });

                    if (contact_data.secondary_contact_uid == "" || contact_data.secondary_contact_uid == null || contact_data.secondary_contact_uid == undefined) {
                      this.second_contact_data = '';
                      this.second_employment_data = '';
                      this.second_income_data = '';
                      this.second_asset_data = '';
                      this.second_liabilities_data = '';
                    } else {
                      this.getContactDetails(contact_data.secondary_contact_uid).subscribe((second_contact_data) => {
                        this.second_contact_data = second_contact_data;
                      });
                      this.getEmployments(contact_data.secondary_contact_uid).subscribe((second_employment_data) => {
                        this.second_employment_data = second_employment_data;
                      });
                      this.getAllIncomess(contact_data.secondary_contact_uid).subscribe((second_income_data) => {
                        this.second_income_data = second_income_data;
                      });
                      this.getAllAssetss(contact_data.secondary_contact_uid).subscribe((second_asset_data) => {
                        this.second_asset_data = second_asset_data;
                      });
                      this.getAllLiabilitiess(contact_data.secondary_contact_uid).subscribe((second_liabilities_data) => {
                        this.second_liabilities_data = second_liabilities_data;
                      });
                    }

                    this.getAllIncomess(contact_data.uid).subscribe((income_data) => {
                      var headers = new Headers();
                      headers.append("Accept", 'application/json');
                      headers.append('Content-Type', 'application/json');
                      const requestOptions = new RequestOptions({ headers: headers });
                      let postData = {
                        'contact_data': contact_data,
                        'employment_data': employment_data[0],
                        'mercuryAgentCode': broker_data[0].mercuryAgentCode,
                        'mercurySeurityToken': broker_data[0].mercurySeurityToken,
                        'income_data': income_data
                      }
                      var url = this.EnvDataService.EnvData.sendbox_api + "/mercurySyncContact";
                      this.http.post(url, postData, requestOptions)
                        .subscribe(getData => {
                          let responseData = JSON.parse(getData['_body']);
                          if (responseData.name != undefined) {
                            this.loadingProvider.stopLoading();
                            this.presentToastSuccess('Something went wrong please try again later.');
                          } else {
                            if (this.second_contact_data.length > 0) {
                              let secondPostData = {
                                'contact_data': this.second_contact_data[0],
                                'employment_data': this.second_employment_data[0],
                                'mercuryAgentCode': broker_data[0].mercuryAgentCode,
                                'mercurySeurityToken': broker_data[0].mercurySeurityToken,
                                'income_data': this.second_income_data
                              }
                              let url = this.EnvDataService.EnvData.sendbox_api + "/mercurySyncContact";
                              this.http.post(url, secondPostData, requestOptions)
                                .subscribe(getSecondData => {
                                  let responseSecondData = JSON.parse(getSecondData['_body']);
                                  if (responseSecondData.name != undefined) {
                                    this.loadingProvider.stopLoading();
                                    this.presentToastSuccess('Something went wrong please try again later.');
                                  } else {
                                    let oppurtunityData = {
                                      'contact_data': contact_data,
                                      'mercuryAgentCode': broker_data[0].mercuryAgentCode,
                                      'mercurySeurityToken': broker_data[0].mercurySeurityToken,
                                      'uniqueId': responseData.uniqueId,
                                      'assets_data': this.assets_data,
                                      'liabilities_data': this.liabilities_data,
                                      'second_uniqueId': responseSecondData.uniqueId,
                                      'second_contact_data': this.second_contact_data[0],
                                      'second_assets_data': this.second_asset_data,
                                      'second_liabilities_data': this.second_liabilities_data,
                                      'realEstate_data': this.realEstate_data
                                    }
                                    let url = this.EnvDataService.EnvData.sendbox_api + "/mercurySyncCreateOportunity";
                                    this.http.post(url, oppurtunityData, requestOptions)
                                      .subscribe(getOData => {
                                        let responseOData = JSON.parse(getOData['_body']);
                                        if (responseOData.name != undefined) {
                                          this.loadingProvider.stopLoading();
                                          this.presentToastSuccess('Oppurtunity not created.');
                                        } else {
                                          this.loadingProvider.stopLoading();
                                          this.presentToastSuccess('Contact sync successfully.');
                                        }
                                      }, error => {
                                        this.loadingProvider.stopLoading();
                                        this.presentToast(error);
                                      });
                                  }
                                });

                            } else {
                              let oppurtunityData = {
                                'contact_data': contact_data,
                                'mercuryAgentCode': broker_data[0].mercuryAgentCode,
                                'mercurySeurityToken': broker_data[0].mercurySeurityToken,
                                'uniqueId': responseData.uniqueId,
                                'assets_data': this.assets_data,
                                'liabilities_data': this.liabilities_data,
                                'second_uniqueId': undefined,
                                'second_contact_data': undefined,
                                'realEstate_data': this.realEstate_data
                              }
                              let url = this.EnvDataService.EnvData.sendbox_api + "/mercurySyncCreateOportunity";
                              this.http.post(url, oppurtunityData, requestOptions)
                                .subscribe(getOData => {
                                  let responseOData = JSON.parse(getOData['_body']);
                                  if (responseOData.name != undefined) {
                                    this.loadingProvider.stopLoading();
                                    this.presentToastSuccess('Oppurtunity not created.');
                                  } else {
                                    this.loadingProvider.stopLoading();
                                    this.presentToastSuccess('Contact sync successfully.');
                                  }
                                }, error => {
                                  this.loadingProvider.stopLoading();
                                  this.presentToast(error);
                                });
                            }
                          }
                        }, error => {
                          this.loadingProvider.stopLoading();
                          this.presentToast(error);
                        });
                    });
                  });
                } else {
                  this.loadingProvider.stopLoading();
                  this.presentToastSuccess('Broker not assigned.');
                }
              });
            }
          }
        }
      ]
    });
    alert.present();
    
  }


  getContactDetails(contact_uid) {
    return this.db.collection<any>("users", ref => ref.where('uid', '==', contact_uid).where('deleted', '==', 0)).valueChanges();
  }

  getBrokerCredentail(contact_uid) {
    return this.db.collection<any>("brokerCredentials", ref => ref.where('uid', '==', contact_uid)).valueChanges();
  }

  getEmployments(contact_uid) {
    return this.db.collection<any>("employment", ref => ref.where('uid', '==', contact_uid).where('deleted', '==', 0)).valueChanges();
  }

  getAllIncomess(contact_uid) {
    return this.db.collection<any>("SDF_income", ref => ref.where('uid', '==', contact_uid).where('deleted', '==', 0)).valueChanges();
  }

  getAllAssetss(contact_uid) {
    return this.db.collection<any>("SDF_assets", ref => ref.where('uid', '==', contact_uid).where('deleted', '==', 0)).valueChanges();
  }

  getAllLiabilitiess(contact_uid) {
    return this.db.collection<any>("SDF_liabilities", ref => ref.where('uid', '==', contact_uid).where('deleted', '==', 0)).valueChanges();
  }

  getAllrealEstate(contact_uid) {
    return this.db.collection<any>("SDF_realestate", ref => ref.where('primary_uid', '==', contact_uid).where('deleted', '==', 0)).valueChanges();
  }

  editContact(event, contact_uid, SDF_form_document_id) {
   
    this.navCtrl.push(AdfPage,{
      user_id:this.user_data.primary_contact_id,
      form_id:this.user_data.adf_form_id,
      edit_flag:'edit'
    });
  }

  presentToastSuccess(success) {
    const toast = this.toastCtrl.create({
      message: success,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  tentative_real_estate(SDF_form_document_id) {
    let primary_id = '';
    let secondary_id = '';
    if (this.primary_secondary_found == "Primary") {
      secondary_id = this.primary_secondary_contact_uid;
      primary_id = this.contact_uid;
    } else {
      primary_id = this.primary_secondary_contact_uid;
      secondary_id = this.contact_uid;
    }
    if (secondary_id == undefined) {
      secondary_id = '';
    }
    window.localStorage.setItem("contact_uid", primary_id);
    window.localStorage.setItem("contact_second_uid", secondary_id);
    this.navCtrl.push(TentativeRealEstateAssetPage, {
      edit_contact_uid: primary_id,
      second_contact_id: secondary_id,
      SDF_form_document_id: SDF_form_document_id
    });
    window.localStorage.setItem("generate_new_tentative", '1');
    this.viewCtrl.dismiss();
  }

  changeEvent(event) {
    if (event.value) {
      this.agreed = true;
    } else {
      this.agreed = false;
    }
  }

  ngAfterViewInit() {

  }
  setAsPrimary($event, contact_uid, group_id, SDF_form_document_id) {
    let alert = this.alertCtrl.create({
      title: 'are you sure',
      message: 'Are you sure you want to set as primary Real Estate?',
      buttons: [
        {
          text: 'No',
          handler: () => {
          
          }
        },
        {
          text: 'Yes',
          handler: () => {
            if (group_id != "") {
              this.loadingProvider.startLoading();
              var headers = new Headers();
              headers.append("Accept", 'application/json');
              headers.append('Content-Type', 'application/json');
              const requestOptions = new RequestOptions({ headers: headers });
              let postData = {
                'contact_uid': contact_uid,
                'group_id': group_id,
                'SDF_form_document_id': SDF_form_document_id
              }
              let url = this.EnvDataService.EnvData.sendbox_api + "/setAsPrimaryRealEstate";
              this.http.post(url, postData, requestOptions)
                .subscribe(data => {
                  if (data['_body'] == "") {
                    this.presentToast('Set as Primary Real Estate Successfully.');
                    this.accessGrantedFromUserstatus = 1;
                  } else {
                    this.presentToast('Something went wrong please try again later.');
                  }
                  this.loadingProvider.stopLoading();
                }, error => {
                  this.presentToast(error.message);
                  this.loadingProvider.stopLoading();
                });
            }
          }
        }
      ]
    });
    alert.present();
  }

  phoneInput(event) {
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  changeEmailPhone(event, form, userType, type) {
    let selectedForm = form;
    if (type == 'email') {
      let getemail = selectedForm.get('email');
      let getmobile_phone = selectedForm.get('mobile_phone');
      getemail.setValidators([Validators.required, Validators.email, Validators.minLength(10), Validators.required]);
      getmobile_phone.setValidators(null);
      getemail.updateValueAndValidity();
      getmobile_phone.updateValueAndValidity();
      if (userType == 'primary') {
        this.editEmailOption = 1;
        this.editPhoneOption = 0;
        this.editEmailOptionSecond = 0;
        this.editPhoneOptionSecond = 0;
      } else if (userType == 'secondary') {
        this.editEmailOptionSecond = 1;
        this.editPhoneOptionSecond = 0;
        this.editEmailOption = 0;
        this.editPhoneOption = 0;
      }
    } else if (type == 'phone') {
      let getemail = selectedForm.get('email');
      let getmobile_phone = selectedForm.get('mobile_phone');
      getmobile_phone.setValidators([Validators.minLength(10), Validators.maxLength(10), Validators.required]);
      getemail.setValidators(null);
      getemail.updateValueAndValidity();
      getmobile_phone.updateValueAndValidity();
      if (userType == 'primary') {
        this.editEmailOption = 0;
        this.editPhoneOption = 1;
        this.editEmailOptionSecond = 0;
        this.editPhoneOptionSecond = 0;
      } else if (userType == 'secondary') {
        this.editEmailOptionSecond = 0;
        this.editPhoneOptionSecond = 1;
        this.editEmailOption = 0;
        this.editPhoneOption = 0;
      }
    }
  }

  closeButton(event) {
    this.editEmailOption = 0;
    this.editPhoneOption = 0;
    this.editEmailOptionSecond = 0;
    this.editPhoneOptionSecond = 0;
  }

  getDimensionsByFilter(group_id, data) {
    return data.filter(x => x.group_id === group_id);
  }

  getAllRealEstateSplitsByTable(document_id) {
    return this.db.collection<any>("SDF_realestate", ref => ref.where('document_id', '==', document_id)).valueChanges();
  }

  updateRealEstateData(asset_id, property, event) {
  
    console.log(this.realestates);

    debugger;


    let property_data = event.target.innerText.trim();
    let property_arr = property_data.split("$");
    let property_value;

    if(property == 'gross_amount') {

      property_value = property_arr[1];
    }
    else {
      property_value = property_data;
    }
    let realestate = [];
    this.realestates.forEach((item,index) => {

       if(index == asset_id) {
        item[property] = property_value;
       }
       
       realestate.push(item);
     });
  
     this.ADFFormService.updaterealstate(this.SDF_form_document_id,this.realestates).then((data)=>{
    
     })

  }

  updateRealEstateMortageData(asset_id, property, event, mortage_id) {
    console.log(this.realestates);

    let property_data = event.target.innerText.trim();
    let balance_arr = property_data.split("$");
    let property_value;
    if(property == 'interest_rate') {
      property_value = balance_arr[0];
    }
    else if(property == 'interest_rate_term' || property == 'loan_type') {
      // property_value = event.target.innerText.trim();
       property_value = event.target.value;
      //  console.log(property_value);
      //  debugger;
    }
    else {
      property_value = balance_arr[1];
    }

    
   
    
   // console.log(current_balance);
    let realestate = [];
    this.realestates.forEach((item,index) => {

       if(index == asset_id) {

        item.itemRowsMortgageSplits.forEach((mortelement,childindex) => {

          if(mortage_id == childindex) {

              mortelement[property] = property_value;
          }
          
        });

        
       }
       
       realestate.push(item);
     });

     console.log(this.realestates);
  
     this.ADFFormService.updaterealstate(this.SDF_form_document_id,this.realestates).then((data)=>{
      console.log(data);
     })
  }

  updateRealEstateTableData(main_id: '', document_id: any, property: string, event: any, id: '', split_id: '') {
   
    if (property == 'address') {
      this.showHideLeaderAddressRealestate[main_id] = 1;
    } else if (property == 'asset_value') {
      this.showHideLeaderAssetValueRealestate[main_id] = 1;
    } else if (property == 'ownership_title_name') {
      this.showHideLeaderOwnershipTitleNameRealestate[main_id] = 1;
    } else if (property == 'gross_amount') {
      this.showHideLeaderGrossAmountRealestate[main_id] = 1;
    } else if (property == 'creditor') {
      this.showHideLeaderCreditorRealestate[main_id][id] = 1;
    } else if (property == 'available_redraw') {
      this.showHideLeaderMortgageLimitRealestate[main_id][id] = 1;
    } else if (property == 'current_balance') {
      this.showHideLeaderCurrentBalanceRealestate[main_id][id] = 1;
    } else if (property == 'interest_rate') {
      this.showHideLeaderIntrestRateRealestate[main_id][id] = 1;
    } else if (property == 'interest_rate_term') {
      this.showHideLeaderInterestRateTermRealestate[main_id][id] = 1;
    } else if (property == 'loan_type') {
      this.showHideLeaderLoanTypeRealestate[main_id][id] = 1;
    } else if (property == 'repayments') {
      this.showHideLeaderRepaymentsRealestate[main_id][id] = 1;
    }
    if (property == 'address' || property == 'asset_value' || property == 'ownership_title_name' || property == 'gross_amount') {
      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');
      const requestOptions = new RequestOptions({ headers: headers });
      let postData = {
        'document_id': document_id,
        'property': property,
        'value': event.target.innerText
      }
      var url = this.EnvDataService.EnvData.sendbox_api + "/updateRealEstateByTable";
      this.http.post(url, postData, requestOptions)
        .subscribe(data => {
          if (property == 'address') {
            this.showHideLeaderAddressRealestate[main_id] = 2;
          } else if (property == 'asset_value') {
            this.showHideLeaderAssetValueRealestate[main_id] = 2;
          } else if (property == 'ownership_title_name') {
            this.showHideLeaderOwnershipTitleNameRealestate[main_id] = 2;
          } else if (property == 'gross_amount') {
            this.showHideLeaderGrossAmountRealestate[main_id] = 2;
          }
          setTimeout(_ => {
            this.showHideLeaderAddressRealestate[main_id] = 0;
            this.showHideLeaderAssetValueRealestate[main_id] = 0;
            this.showHideLeaderOwnershipTitleNameRealestate[main_id] = 0;
            this.showHideLeaderGrossAmountRealestate[main_id] = 0;
          }, 2000);
        }, error => {
          if (property == 'address') {
            this.showHideLeaderAddressRealestate[main_id] = 2;
          } else if (property == 'asset_value') {
            this.showHideLeaderAssetValueRealestate[main_id] = 2;
          } else if (property == 'ownership_title_name') {
            this.showHideLeaderOwnershipTitleNameRealestate[main_id] = 2;
          } else if (property == 'gross_amount') {
            this.showHideLeaderGrossAmountRealestate[main_id] = 2;
          }
          setTimeout(_ => {
            this.showHideLeaderAddressRealestate[main_id] = 0;
            this.showHideLeaderAssetValueRealestate[main_id] = 0;
            this.showHideLeaderOwnershipTitleNameRealestate[main_id] = 0;
            this.showHideLeaderGrossAmountRealestate[main_id] = 0;
          }, 2000);
        });
    } else {
      let thiss = this;
      var docRef1 = firebase.firestore().collection("SDF_realestate").doc(document_id);
      docRef1.get().then(function (doc) {
        if (doc.exists) {
          let data = doc.data();
          if (property == 'creditor') {
            data.split[id].creditor = event.target.innerText;
          } else if (property == 'available_redraw') {
            data.split[id].available_redraw = event.target.innerText.split("$").join("").split(",").join("");
          } else if (property == 'current_balance') {
            data.split[id].current_balance = event.target.innerText.split("$").join("").split(",").join("");
          } else if (property == 'interest_rate') {
            data.split[id].interest_rate = event.target.innerText.split("%").join("");
          } else if (property == 'interest_rate_term') {
            data.split[id].interest_rate_term = event.target.innerText;
          } else if (property == 'loan_type') {
            data.split[id].loan_type = event.target.innerText;
          } else if (property == 'repayments') {
            data.split[id].repayments = event.target.innerText.split("$").join("").split(",").join("");
          }
          var headers = new Headers();
          headers.append("Accept", 'application/json');
          headers.append('Content-Type', 'application/json');
          const requestOptions = new RequestOptions({ headers: headers });
          let postData = {
            'document_id': document_id,
            'property': property,
            'value': event.target.innerText,
            'split': data.split,
            'split_id': split_id,
            'id': id
          }
          let url = this.EnvDataService.EnvData.sendbox_api + "/updateRealEstateByTable";
          thiss.http.post(url, postData, requestOptions)
            .subscribe(data => {
              if (property == 'creditor') {
                thiss.showHideLeaderCreditorRealestate[main_id][id] = 2;
              } else if (property == 'available_redraw') {
                thiss.showHideLeaderMortgageLimitRealestate[main_id][id] = 2;
              } else if (property == 'current_balance') {
                thiss.showHideLeaderCurrentBalanceRealestate[main_id][id] = 2;
              } else if (property == 'interest_rate') {
                thiss.showHideLeaderIntrestRateRealestate[main_id][id] = 2;
              } else if (property == 'interest_rate_term') {
                thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 2;
              } else if (property == 'loan_type') {
                thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 2;
              } else if (property == 'repayments') {
                thiss.showHideLeaderRepaymentsRealestate[main_id][id] = 2;
              }
              setTimeout(_ => {
                thiss.showHideLeaderCreditorRealestate[main_id][id] = 0;
                thiss.showHideLeaderMortgageLimitRealestate[main_id][id] = 0;
                thiss.showHideLeaderCurrentBalanceRealestate[main_id][id] = 0;
                thiss.showHideLeaderIntrestRateRealestate[main_id][id] = 0;
                thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 0;
                thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 0;
                thiss.showHideLeaderRepaymentsRealestate[main_id][id] = 0;
              }, 2000);
            }, error => {
              if (property == 'creditor') {
                thiss.showHideLeaderCreditorRealestate[main_id][id] = 2;
              } else if (property == 'available_redraw') {
                thiss.showHideLeaderMortgageLimitRealestate[main_id][id] = 2;
              } else if (property == 'current_balance') {
                thiss.showHideLeaderCurrentBalanceRealestate[main_id][id] = 2;
              } else if (property == 'interest_rate') {
                thiss.showHideLeaderIntrestRateRealestate[main_id][id] = 2;
              } else if (property == 'interest_rate_term') {
                thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 2;
              } else if (property == 'loan_type') {
                thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 2;
              } else if (property == 'repayments') {
                thiss.showHideLeaderRepaymentsRealestate[main_id][id] = 2;
              }
              setTimeout(_ => {
                thiss.showHideLeaderCreditorRealestate[main_id][id] = 0;
                thiss.showHideLeaderMortgageLimitRealestate[main_id][id] = 0;
                thiss.showHideLeaderCurrentBalanceRealestate[main_id][id] = 0;
                thiss.showHideLeaderIntrestRateRealestate[main_id][id] = 0;
                thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 0;
                thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 0;
                thiss.showHideLeaderRepaymentsRealestate[main_id][id] = 0;
              }, 2000);
            });
        }
      });
    }
  }

  updateRealEstateTableDataSelect(main_id: '', document_id: any, property: string, event: any, id: '', split_id: '') {
    if (property == 'interest_rate_term') {
      this.showHideLeaderInterestRateTermRealestate[main_id][id] = 1;
    } else if (property == 'loan_type') {
      this.showHideLeaderLoanTypeRealestate[main_id][id] = 1;
    }
    let thiss = this;
    var docRef1 = firebase.firestore().collection("SDF_realestate").doc(document_id);
    docRef1.get().then(function (doc) {
      if (doc.exists) {
        let data = doc.data();
        if (property == 'interest_rate_term') {
          data.split[id].interest_rate_term = event.target.value;
        } else if (property == 'loan_type') {
          data.split[id].loan_type = event.target.value;
        }
        var headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json');
        const requestOptions = new RequestOptions({ headers: headers });
        let postData = {
          'document_id': document_id,
          'property': property,
          'value': event.target.value,
          'split': data.split,
          'split_id': split_id,
          'id': id
        }
        let url = this.EnvDataService.EnvData.sendbox_api + "/updateRealEstateByTable";
        thiss.http.post(url, postData, requestOptions)
          .subscribe(data => {
            if (property == 'interest_rate_term') {
              thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 2;
            } else if (property == 'loan_type') {
              thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 2;
            }
            setTimeout(_ => {
              thiss.showHideLeaderCreditorRealestate[main_id][id] = 0;
              thiss.showHideLeaderMortgageLimitRealestate[main_id][id] = 0;
              thiss.showHideLeaderCurrentBalanceRealestate[main_id][id] = 0;
              thiss.showHideLeaderIntrestRateRealestate[main_id][id] = 0;
              thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 0;
              thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 0;
              thiss.showHideLeaderRepaymentsRealestate[main_id][id] = 0;
            }, 2000);
          }, error => {
            if (property == 'interest_rate_term') {
              thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 2;
            } else if (property == 'loan_type') {
              thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 2;
            }
            setTimeout(_ => {
              thiss.showHideLeaderCreditorRealestate[main_id][id] = 0;
              thiss.showHideLeaderMortgageLimitRealestate[main_id][id] = 0;
              thiss.showHideLeaderCurrentBalanceRealestate[main_id][id] = 0;
              thiss.showHideLeaderIntrestRateRealestate[main_id][id] = 0;
              thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 0;
              thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 0;
              thiss.showHideLeaderRepaymentsRealestate[main_id][id] = 0;
            }, 2000);
          });
      }
    });
  }

  updateTentativeRealEstateTableData(main_id: any, id: any, id1: any, document_id: any, property: string, event: any, split_id: '') {
    if (property == 'address') {
      this.showHideLeaderAddressTentaRealestate[main_id][id] = 1;
    } else if (property == 'asset_value') {
      this.showHideLeaderAssetValueTentaRealestate[main_id][id] = 1;
    } else if (property == 'ownership_title_name') {
      this.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 1;
    } else if (property == 'gross_amount') {
      this.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 1;
    } else if (property == 'creditor') {
      this.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 1;
    } else if (property == 'available_redraw') {
      this.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 1;
    } else if (property == 'current_balance') {
      this.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 1;
    } else if (property == 'interest_rate') {
      this.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 1;
    } else if (property == 'interest_rate_term') {
      this.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 1;
    } else if (property == 'loan_type') {
      this.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 1;
    } else if (property == 'repayments') {
      this.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 1;
    }

    if (property == 'address' || property == 'asset_value' || property == 'ownership_title_name' || property == 'gross_amount') {
      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');
      const requestOptions = new RequestOptions({ headers: headers });
      let postData = {
        'document_id': document_id,
        'property': property,
        'value': event.target.innerText
      }
      let url = this.EnvDataService.EnvData.sendbox_api + "/updateTentativeRealEstateByTable";
      this.http.post(url, postData, requestOptions)
        .subscribe(data => {
          this.showCurrentTentativetable = true;
          this.showCurrentTentativetableIndex = main_id;

          if (property == 'address') {
            this.showHideLeaderAddressTentaRealestate[main_id] = 2;
          } else if (property == 'asset_value') {
            this.showHideLeaderAssetValueTentaRealestate[main_id][id] = 2;
          } else if (property == 'ownership_title_name') {
            this.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 2;
          } else if (property == 'gross_amount') {
            this.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 2;
          }
          setTimeout(_ => {
            this.showHideLeaderAddressTentaRealestate[main_id][id] = 0;
            this.showHideLeaderAssetValueTentaRealestate[main_id][id] = 0;
            this.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 0;
            this.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 0;
            this.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 0;
            this.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 0;
            this.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 0;
            this.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 0;
            this.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 0;
            this.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 0;
            this.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 0;
          }, 2000);

        }, error => {
          this.showCurrentTentativetable = true;
          this.showCurrentTentativetableIndex = main_id;

          setTimeout(_ => {
            this.showHideLeaderAddressTentaRealestate[main_id][id] = 0;
            this.showHideLeaderAssetValueTentaRealestate[main_id][id] = 0;
            this.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 0;
            this.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 0;
            this.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 0;
            this.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 0;
            this.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 0;
            this.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 0;
            this.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 0;
            this.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 0;
            this.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 0;
          }, 2000);
        });
    } else {
      let thiss = this;
      var docRef1 = firebase.firestore().collection("tentative_real_estate").doc(document_id);
      docRef1.get().then(function (doc) {
        if (doc.exists) {
          let data = doc.data();
          if (property == 'creditor') {
            data.split[id1].creditor = event.target.innerText;
          } else if (property == 'available_redraw') {
            data.split[id1].available_redraw = event.target.innerText.split("$").join("").split(",").join("");
          } else if (property == 'current_balance') {
            data.split[id1].current_balance = event.target.innerText.split("$").join("").split(",").join("");
          } else if (property == 'interest_rate') {
            data.split[id1].interest_rate = event.target.innerText.split("%").join("");
          } else if (property == 'interest_rate_term') {
            data.split[id1].interest_rate_term = event.target.innerText;
          } else if (property == 'loan_type') {
            data.split[id1].loan_type = event.target.innerText;
          } else if (property == 'repayments') {
            data.split[id1].repayments = event.target.innerText.split("$").join("").split(",").join("");
          }
          var headers = new Headers();
          headers.append("Accept", 'application/json');
          headers.append('Content-Type', 'application/json');
          const requestOptions = new RequestOptions({ headers: headers });
          let postData = {
            'document_id': document_id,
            'property': property,
            'value': event.target.innerText,
            'split': data.split,
            'split_id': split_id,
            'id': id
          }
          let url = this.EnvDataService.EnvData.sendbox_api + "/updateTentativeRealEstateByTable";
          thiss.http.post(url, postData, requestOptions)
            .subscribe(data => {
              thiss.showCurrentTentativetable = true;
              thiss.showCurrentTentativetableIndex = main_id;

              if (property == 'creditor') {
                thiss.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 2;
              } else if (property == 'available_redraw') {
                thiss.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 2;
              } else if (property == 'current_balance') {
                thiss.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 2;
              } else if (property == 'interest_rate') {
                thiss.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 2;
              } else if (property == 'interest_rate_term') {
                thiss.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 2;
              } else if (property == 'loan_type') {
                thiss.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 2;
              } else if (property == 'repayments') {
                thiss.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 2;
              }

              setTimeout(_ => {
                thiss.showHideLeaderAddressTentaRealestate[main_id][id] = 0;
                thiss.showHideLeaderAssetValueTentaRealestate[main_id][id] = 0;
                thiss.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 0;
                thiss.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 0;
                thiss.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 0;
                thiss.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 0;
                thiss.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 0;
                thiss.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 0;
                thiss.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 0;
                thiss.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 0;
                thiss.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 0;
              }, 2000);


            }, error => {
              thiss.showCurrentTentativetable = true;
              thiss.showCurrentTentativetableIndex = main_id;

              setTimeout(_ => {
                thiss.showHideLeaderAddressTentaRealestate[main_id][id] = 0;
                thiss.showHideLeaderAssetValueTentaRealestate[main_id][id] = 0;
                thiss.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 0;
                thiss.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 0;
                thiss.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 0;
                thiss.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 0;
                thiss.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 0;
                thiss.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 0;
                thiss.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 0;
                thiss.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 0;
                thiss.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 0;
              }, 2000);

            });
        }
      });
    }
  }


  updateTentaRealEstateTableDataSelect(main_id: any, id: any, id1: any, document_id: any, property: string, event: any, split_id: '') {
    if (property == 'interest_rate_term') {
      this.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 1;
    } else if (property == 'loan_type') {
      this.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 1;
    }
    let thiss = this;
    var docRef1 = firebase.firestore().collection("tentative_real_estate").doc(document_id);
    docRef1.get().then(function (doc) {
      if (doc.exists) {
        let data = doc.data();
        if (property == 'interest_rate_term') {
          data.split[id1].interest_rate_term = event.target.value;
        } else if (property == 'loan_type') {
          data.split[id1].loan_type = event.target.value;
        }
        var headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json');
        const requestOptions = new RequestOptions({ headers: headers });
        let postData = {
          'document_id': document_id,
          'property': property,
          'value': event.target.value,
          'split': data.split,
          'split_id': split_id,
          'id': id
        }
        let url = this.EnvDataService.EnvData.sendbox_api + "/updateTentativeRealEstateByTable";
        thiss.http.post(url, postData, requestOptions)
          .subscribe(data => {
            thiss.showCurrentTentativetable = true;
            thiss.showCurrentTentativetableIndex = main_id;
            if (property == 'interest_rate_term') {
              thiss.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 2;
            } else if (property == 'loan_type') {
              thiss.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 2;
            }
            setTimeout(_ => {
              thiss.showHideLeaderAddressTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderAssetValueTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 0;
            }, 2000);
          }, error => {
            thiss.showCurrentTentativetable = true;
            thiss.showCurrentTentativetableIndex = main_id;
            setTimeout(_ => {
              thiss.showHideLeaderAddressTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderAssetValueTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 0;
            }, 2000);
          });
      }
    });
  }

  changeValue(id: number, property: string, event: any) {
  
  }

  hideShowTableView(i, status) {
    if (status) {
      this.showHideTentativetable[i] = false;
    } else {
      this.showHideTentativetable[i] = true;
    }
  }

  unapproved(firstname, lastname) {
    debugger;
    let uid = window.localStorage.getItem("uid");
    let brokerName = window.localStorage.getItem("brokerFirstname") + ' ' + window.localStorage.getItem("brokerLastname");
    this.userRole = window.localStorage.getItem("userRole");
    let alert = this.alertCtrl.create({
      title: 'Are you sure',
      message: 'Do you want to reset the customer approval of this contact?',
      buttons: [
        {
          text: 'No',
          handler: () => {
           
          }
        },
        {
          text: 'Yes',
          handler: () => {
            if (this.contact_uid != "") {
              this.loadingProvider.startLoading();
              var headers = new Headers();
              headers.append("Accept", 'application/json');
              headers.append('Content-Type', 'application/json');
              const requestOptions = new RequestOptions({ headers: headers });
              let priSec_uid = '';
              if (this.priSec_uid != null) {
                priSec_uid = this.priSec_uid;
              }
              let pri_contact_uid = this.contact_uid;
              if (this.user_data.contact_type != 'Primary Contact') {
                pri_contact_uid = this.priSec_uid;
              }
              let ckuserRole = 'Broker';
              if (this.userRole == 'super_admin') {
                ckuserRole = 'Super Admin';
              } else if (this.userRole == 'loan_admin') {
                ckuserRole = 'Loan Admin';
              }
              let postData = {
                'contact_uid': this.contact_uid,
                'priSec_uid': priSec_uid,
                "created_date": new Date().getTime(),
                //"contact_type": this.user_data.contact_type,
               // "pri_contact_uid": pri_contact_uid,
               //"pri_contact_uid": this.contact_uid,
                "brokerName": brokerName,
                "userRole": ckuserRole,
                "user_history_created_by": uid,
                "name": firstname + ' ' + lastname,
                "SDF_form_document_id": this.SDF_form_document_id
              }
              console.log(postData);
              //
              // let url = this.EnvDataService.EnvData.sendbox_api + "/unapprovedSubmittion";
              let url = this.EnvDataService.EnvData.sendbox_api + "/unapprovedAdfSubmittion";
              this.http.post(url, postData, requestOptions)
                .subscribe(data => {
                  if (data['_body'] == 'error') {
                    this.presentToast('Something went wrong please try again later.');
                  } else {
                    this.presentToast('Reset customer approval successfully.');
                    this.user_data.accessGrantedFromUser = 0;
                    postData['ip_address'] = data['_body'];
                    postData['status'] = 5;
                    this.user_history_data(postData)
                  }
                  this.loadingProvider.stopLoading();
                }, error => {
                  this.presentToast(error.message);
                });
            }
          }
        }
      ]
    });
    alert.present();
  }

  resetAllPremission() {
    let brokerName = window.localStorage.getItem("brokerFirstname") + ' ' + window.localStorage.getItem("brokerLastname");
    this.userRole = window.localStorage.getItem("userRole");
    let alert = this.alertCtrl.create({
      title: 'Are you sure',
      message: 'Do you want to reset the customer permission of this contact?',
      buttons: [
        {
          text: 'No',
          handler: () => {
           
          }
        },
        {
          text: 'Yes',
          handler: () => {
            if (this.contact_uid != "") {
              this.loadingProvider.startLoading();
              var headers = new Headers();
              headers.append("Accept", 'application/json');
              headers.append('Content-Type', 'application/json');
              const requestOptions = new RequestOptions({ headers: headers });
              let priSec_uid = '';
              if (this.priSec_uid != null) {
                priSec_uid = this.priSec_uid;
              }
              let pri_contact_uid = this.contact_uid;
              if (this.user_data.contact_type != 'Primary Contact') {
                pri_contact_uid = this.priSec_uid;
              }
              let ckuserRole = 'Broker';
              if (this.userRole == 'super_admin') {
                ckuserRole = 'Super Admin';
              } else if (this.userRole == 'loan_admin') {
                ckuserRole = 'Loan Admin';
              }
              let postData = {
                'contact_uid': this.contact_uid,
                'priSec_uid': priSec_uid,
                "created_date": new Date().getTime(),
                "contact_type": this.user_data.contact_type,
                "pri_contact_uid": pri_contact_uid,
                "brokerName": brokerName,
                "userRole": ckuserRole
              }
              var url = this.EnvDataService.EnvData.sendbox_api + "/resetAllPremission";
              this.http.post(url, postData, requestOptions)
                .subscribe(data => {
                  if (data['_body'] == 'success') {
                    this.presentToast('Reset customer permission successfully.');
                    this.user_data.allowCustoViewOnlyPermission = 0;
                    this.user_data.allowCustoeditPermission = 0;
                    this.loadingProvider.stopLoading();
                  } else {
                    this.presentToast('Something went wrong please try again later.');
                    this.loadingProvider.stopLoading();
                  }
                }, error => {
                  this.presentToast(error.message);
                });
            }
          }
        }
      ]
    });
    alert.present();
  }

  uploadImage(event, uid) {
    if (this.all_documents.length == 0) {
      this.all_documents = this.user_data.all_documents;
    }


    if (this.all_documents == undefined) {
      this.all_documents = [];
    }


    if (event.target.files && event.target.files[0]) {
      let document_name = event.target.name;
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
    
      reader.onload = (e: any) => { 
        this.url = e.target.result;
      
        const fileraw = event.target.files[0];
        const filePath = '/User Documents/' + uid + '/' + document_name + '_' + (Math.floor(1000 + Math.random() * 9000) + 1);
        const result = this.SaveImageRef(filePath, fileraw);
        const ref = result.ref;
        this.percentage = result.task.percentageChanges();
        this.percentageArea = document_name;
        result.task.then(a => {
          ref.getDownloadURL().subscribe(a => {
            let status_url = 0;
            if (this.all_documents.length > 0) {
              for (let i = 0; i < this.all_documents.length; i++) {
                if (this.all_documents[i].name == document_name) {
                  this.all_documents[i].url = a;
                  status_url = 1;
                }
              }
            }
            if (status_url == 0) {
              this.all_documents.push({ 'name': document_name, 'url': a });
            }
            var headers = new Headers();
            headers.append("Accept", 'application/json');
            headers.append('Content-Type', 'application/json');
            const requestOptions = new RequestOptions({ headers: headers });
            let postData = {
              'contact_uid': uid,
              'document_name': document_name,
              'document_url': a
            }
            let url = this.EnvDataService.EnvData.sendbox_api + "/emailDocumentUploadByContact";
            this.http.post(url, postData, requestOptions)
              .subscribe(data => {
                this.presentToast('Document uploaded successfully.');
              }, error => {
                this.presentToast(error.message);
              });
            this.db.collection('users').doc(uid).update({
              all_documents: this.all_documents
            });
            this.user_data.all_documents = this.all_documents;
          });
        });
      }, error => {
     
      }

    }
  }
  SaveImageRef(filePath, file) {

    return {
      task: this.storage.upload(filePath, file),
      ref: this.storage.ref(filePath)
    };
  }

  viewUserHistory(event, document_id) {
    let viewUserHistory = this.modalCtrl.create(HistoryDetailsPage, {
      "document_id": document_id,
      "SDF_form_document_id": this.SDF_form_document_id
    });

    viewUserHistory.present();
  }

  viewMoreAddress(user_data) {
    debugger;
    //
    let previousadress = [];

    this.user_address.forEach(addresselement => {
        if(addresselement.type == 'previous') {
          previousadress.push(addresselement);
        }
     });
     user_data.previousAddress= previousadress;

    let viewMoreAddress = this.modalCtrl.create(ViewMoreAddressPage, {
      "user_data": user_data
    });

    viewMoreAddress.present();
  }
  viewAddMoreAddress(user_data) {
    debugger;
    let previousadress = [];
    let currentaddress = [];

    user_data.forEach(addresselement => {
        if(addresselement.type == 'previous') {
          previousadress.push(addresselement);
        }
        else {
          currentaddress.push(addresselement);
        }
     });
    let new_address = currentaddress[0];

     new_address.previousAddress = previousadress;

    let viewMoreAddress = this.modalCtrl.create(ViewMoreAddressPage, {
      "user_data": new_address
    });
    viewMoreAddress.present();

  }
  showadditionalcontact(event,user_id) {
    this.navCtrl.push(ShowContactForm,{
      contact_uid:user_id,
    });
  }
  changeAdfStatus(event) {
    let thiss = this;
     debugger;
    this.adfFormStatus = event;
    if(event) {
      thiss.adf_data.application_status = 'open';
    }
    else {
      thiss.adf_data.application_status = 'closed';
    }
    let edit_form_id = this.SDF_form_document_id;
    this.ADFFormService.update_adf_status(edit_form_id,event).then(()=>{
     // console.log('working');
     
    })

  }
  ionViewDidLoad() {
    let thiss = this;
    this.navBar.backButtonClick = () => {
      // Write here what you wanna do
      
      if(thiss.userRole == 'contact') {
        thiss.navCtrl.push(ShowContactForm);
      }
      else {
          thiss.navCtrl.pop();
        //thiss.navCtrl.push(AdfList);
      }
      
  }
}
  checkingtest() {
    debugger;
    console.log('working');
  }

}



// WEBPACK FOOTER //
// ./src/pages/view-adf/view-adf.ts